(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var Dot = require('./track/Dot');
var Event = require('./track/Event');
var EventCustom = require('./track/EventCustom');
var EventCustomDefinition = require('./track/EventCustomDefinition');
var NMEAFormatter = require('./utils/NMEAFormatter');
function FollowMeMapUtils() {}
FollowMeMapUtils.restoreDot = function (rawDot) {
  var dot = new Dot(rawDot.lat, rawDot.lon);
  var event = this.restoreEvent(rawDot.event, rawDot.eventType);
  if (event) {
    dot.setEventFromTable(event);
  }
  return dot;
};
FollowMeMapUtils.restoreEvent = function (event, eventType) {
  if (!event) return false;
  switch (eventType) {
    case 'Event':
      return new Event(event._id, event._name, event._description, event._color, event._isDefault, event._isDrawable);
    case 'EventCustomDefinition':
      return new EventCustomDefinition(event._id, event._color, event._definition, event._isDrawable);
    case 'EventCustom':
      return new EventCustom(event._id, event._name, event._content, event._color, event._isDrawable);
  }
};

/**
 * Translates a Dots collection to a CSV readable by the sever
 * @param {Dots} dots
 * @param includeCustomEventDefinitions
 * @param {string} format
 * @param {boolean} keepExactContent
 * @returns {string}
 */
FollowMeMapUtils.prepareForExport = function (dots, includeCustomEventDefinitions, format, keepExactContent) {
  if (!format) format = 'csv';
  switch (format) {
    case 'csv':
    default:
      return this.prepareForExportCSV(dots, includeCustomEventDefinitions, keepExactContent);
    case 'nmea':
      return this.prepareForExportNMEA(dots, includeCustomEventDefinitions, keepExactContent);
  }
};

/**
 *
 * @param {Dot[]} dots
 * @param {boolean} includeCustomEventDefinitions
 * @param {boolean} keepExactContent - if the content should be modified (e.g. if the description is missing, taking it from the name)
 * @returns {string}
 */
FollowMeMapUtils.prepareForExportCSV = function (dots, includeCustomEventDefinitions, keepExactContent) {
  var rowSeparator = ';';
  var header = ['lat', 'long', 'EVT_TYPE', 'EVT_DESCR', 'EVT_ID', 'EVT_NAME', 'EVT_COLOR', 'EVT_DEFAULT'];
  var customEventIds = [];
  var definitions = [];
  if (typeof window !== 'undefined') {
    definitions = window.storage.getCustomEventDefinitions();
  }
  if (!keepExactContent) {
    header.concat(['eventCode', 'eventText']);
  }
  if (dots.get().length <= 0) return;
  var populateArrayWithEvent = function populateArrayWithEvent(index, array, dot) {
    if (!dot.hasEvent()) return array;
    var event = dot.getEvent();
    switch (event.constructor.name) {
      case 'Event':
        var keepContentForEvent = keepExactContent;
        var description = event.getDescription();
        var eventId = event.getIsDefault() === true ? event.getId() : 1;
        if (eventId === 65555 || eventId === 65553) keepContentForEvent = true;
        if (!keepContentForEvent && event.getName() && event.getName() !== "" && description !== "") {
          description = event.getName() + ": " + event.getDescription();
        } else if (!keepContentForEvent && event.getName() && event.getName() !== "" && description === "") {
          description = event.getName();
        }
        array[header.indexOf('EVT_TYPE')] = eventId;
        array[header.indexOf('EVT_DESCR')] = description;
        array[header.indexOf('EVT_ID')] = eventId;
        array[header.indexOf('EVT_NAME')] = event.getName();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('EVT_DEFAULT')] = event.getIsDefault();
        if (!keepContentForEvent) {
          array[header.indexOf('eventCode')] = eventId;
          array[header.indexOf('eventText')] = description;
        }
        break;
      case 'EventCustom':
        var eventIndex = 50000 + index;
        var eventDefinition = definitions.find(function (e) {
          return e._id === event.getId();
        });
        var formattedContent = '';
        Object.keys(event.getContent()).forEach(function (key, i) {
          formattedContent += key + '=' + event.getContent()[key];
          if (i !== Object.keys(event.getContent()).length - 1) {
            formattedContent += ',';
          }
        });
        array[header.indexOf('EVT_TYPE')] = event.getId();
        array[header.indexOf('EVT_DESCR')] = formattedContent;
        array[header.indexOf('eventCode')] = event.getId();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('eventText')] = JSON.stringify('evenTextWo?');
        break;
      /*
      case 'EventCustom':
        var parseEventText = function () {
          var content = event.getContent();
          var outputArray = [];
           for(var i in content) {
            if(!content.hasOwnProperty(i) || content[i] === null) continue;
            outputArray.push(i+"="+content[i]);
          }
           return outputArray.join(",");
        };
         array[header.indexOf('EVT_TYPE')] = event.getId();
        array[header.indexOf('EVT_DESCR')] = parseEventText();
        array[header.indexOf('eventCode')] = event.getId();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('eventText')] = parseEventText();
         break;*/
    }
    return array;
  };
  var output = header.join(rowSeparator) + '\n';
  dots.get().forEach(function (dot, index) {
    var event = dot.getEvent();
    if (dot.hasEvent() && event.constructor.name === 'EventCustom') {
      customEventIds.push(event.getId());
    }
  });
  if (includeCustomEventDefinitions) {
    var id = 50000;
    var usedDefinitions = definitions.filter(function (def) {
      return customEventIds.includes(def._definition.code);
    });
    var coordinatesLatitude = dots.get()[0].getLatitude().toString();
    var coordinatesLongitude = dots.get()[0].getLongitude().toString();
    usedDefinitions.forEach(function (def) {
      var outputArray = [coordinatesLatitude, coordinatesLongitude];
      for (var i = 0; i < header.length - 2; i++) {
        outputArray.push("");
      }
      var definition = new EventCustomDefinition(def._id, def._color, def._definition, def._isDrawable);
      outputArray[header.indexOf('EVT_TYPE')] = id;
      outputArray[header.indexOf('EVT_DESCR')] = JSON.stringify(definition.getDefinition());
      outputArray[header.indexOf('eventCode')] = def._id;
      outputArray[header.indexOf('EVT_COLOR')] = definition.getColor();
      outputArray[header.indexOf('eventText')] = JSON.stringify(definition.getDefinition());
      output += outputArray.join(rowSeparator) + '\n';
      id++;
    });
  }
  dots.get().forEach(function (dot, index) {
    var outputArray = [dot.getLatitude().toString(), dot.getLongitude().toString()];

    //Pre-populate events columns with empty values
    for (var i = 0; i < header.length - 2; i++) {
      outputArray.push("");
    }
    outputArray = populateArrayWithEvent(index, outputArray, dot);
    output += outputArray.join(rowSeparator) + '\n';
  });
  return output;
};
FollowMeMapUtils.getNMEAEventRow = function (dot, index, keepExactContent) {
  var event = dot.getEvent();
  var row = [];
  switch (event.constructor.name) {
    case 'Event':
      var description = event.getDescription();
      if (!keepExactContent && event.getName() && event.getName() !== "" && description !== "") {
        description = event.getName() + ": " + event.getDescription();
      } else if (!keepExactContent && event.getName() && event.getName() !== "" && description === "") {
        description = event.getName();
      }
      var eventId = event.getIsDefault() === true ? event.getId() : 1;
      row = ['$IWEVENT', eventId, description, dot.getLongitude(), dot.getLatitude()];
      break;
    case 'EventCustomDefinition':
      var eventIndex = 50000 + index;
      row = ['$IWEVENTDEFINITION', eventIndex, JSON.stringify(event.getDefinition()), dot.getLongitude(), dot.getLatitude()];
      break;
    case 'EventCustom':
      var parseEventText = function parseEventText() {
        var content = event.getContent();
        var outputArray = [];
        for (var i in content) {
          if (!content.hasOwnProperty(i) || content[i] === null) continue;
          outputArray.push(i + "=" + content[i]);
        }
        return outputArray.join(",");
      };
      row = ['$IWEVENT', event.getId(), parseEventText(), dot.getLongitude(), dot.getLatitude()];
      break;
  }
  return row.join(',');
};
FollowMeMapUtils.prepareForExportNMEA = function (dots, includeCustomEventDefinitions) {
  var nmeaFormatter = new NMEAFormatter();
  var output = [];
  var definitions = window.storage.getCustomEventDefinitions();
  var trackname = window.storage.getTrackInfo().fileName.replace(/ /g, "-");
  var id = 50000;
  if (definitions.hasOwnProperty(trackname) && definitions[trackname].length > 0) {
    var coordinatesLatitude = dots.get()[0].getLatitude().toString();
    var coordinatesLongitude = dots.get()[0].getLongitude().toString();
    definitions[trackname].forEach(function (definition) {
      output.push(['$IWEVENTDEFINITION', id, JSON.stringify(definition.getDefinition()), coordinatesLongitude, coordinatesLatitude].join(','));
      id++;
    });
  }
  dots.get().forEach(function (dot, index) {
    var coordinate = dot.getCoordinate();
    if (dot.hasEvent()) {
      output.push(this.getNMEAEventRow(dot, index));
    } else {
      output.push(nmeaFormatter.format(coordinate));
    }
  }.bind(this));
  return output.join('\n');
};
FollowMeMapUtils.getUserConfig = function (company, username) {
  var user = {
    company: '',
    username: ''
  };
  typeof company !== 'undefined' ? user.company = company : user.company = window.storage.getCompany();
  typeof username !== 'undefined' ? user.username = username : user.username = window.storage.getUsername();
  var userConfig;
  var specificUsernameKey = user.company + "/" + user.username;
  var specificCompanyKey = user.company + "/*";
  var generalKey = "*/*";
  if (Object.prototype.hasOwnProperty.call(CONSTANTS.MAP_RESTRICTIONS_PER_USER, specificUsernameKey)) {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[specificUsernameKey];
  } else if (Object.prototype.hasOwnProperty.call(CONSTANTS.MAP_RESTRICTIONS_PER_USER, specificCompanyKey)) {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[specificCompanyKey];
  } else {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[generalKey];
  }
  return userConfig;
};
FollowMeMapUtils.sortMapTypes = function (mapTypes) {
  mapTypes.sort(function (a, b) {
    var aString = a.provider + a.version;
    var bString = b.provider + b.version;
    if (aString < bString) {
      return -1;
    }
    if (aString > bString) {
      return 1;
    }
    return 0;
  });
  return mapTypes;
};
if (typeof window !== "undefined") window.FollowMeMapUtils = FollowMeMapUtils;
module.exports = FollowMeMapUtils;

},{"./track/Dot":4,"./track/Event":6,"./track/EventCustom":7,"./track/EventCustomDefinition":8,"./utils/NMEAFormatter":11}],2:[function(require,module,exports){
"use strict";

function FollowMeUtils() {}

/**
 * Creates a hash based on a string
 * Based on https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param {string} string
 * @static
 */
FollowMeUtils.hashString = function (string) {
  var hash = 0;
  var character;
  if (string.length === 0) return hash;
  for (var i = 0; i < string.length; i++) {
    character = string.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
};
module.exports = FollowMeUtils;

},{}],3:[function(require,module,exports){
'use strict';

var _Dot = _interopRequireDefault(require("./track/Dot"));
var _Dots = _interopRequireDefault(require("./track/Dots"));
var _Event = _interopRequireDefault(require("./track/Event"));
var _EventCustom = _interopRequireDefault(require("./track/EventCustom"));
var _InstructionsTranslator = _interopRequireDefault(require("./utils/InstructionsTranslator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FollowMeMapUtils = require('./FollowMeMapUtils');
var classifyPoint = require('robust-point-in-polygon');

/**
 *
 * @param querySelector
 * @param mapTypeObject
 * @constructor
 */
var FollowmeMap = /*#__PURE__*/function () {
  function FollowmeMap(querySelector, mapTypeObject) {
    var _this = this;
    _classCallCheck(this, FollowmeMap);
    this.map = new window.IWMap(document.querySelector(querySelector));
    var mapType = this.getMapType(mapTypeObject);
    var userConfig = FollowMeMapUtils.getUserConfig();
    mapType.setRenderingConfig(window.vectorMapConfig);
    mapType.setMaxLevel(18);
    this.map.setCenter(new window.IWCoordinate(userLocationCoordinates.longitude, userLocationCoordinates.latitude, 'WGS84'), userConfig.defaultZoomLevel ? userConfig.defaultZoomLevel : 17, mapType);
    this.routeRenderer = new window.IWMapRenderer(this.map);
    this.baseLinesRenderer = new window.IWMapRenderer(this.map);
    this.lineToMouseRenderer = new window.IWMapRenderer(this.map);
    this.statusAndRemarksRenderer = new window.IWMapRenderer(this.map);
    this.selectPolygonRenderer = new window.IWMapRenderer(this.map);
    this.selectPolygonActive = false;
    this.clickedCoordinates = [];

    // Consists objects with map dots/markers/event markers
    this.mapDots = new _Dots["default"]();
    this.editingTracks = {};
    this.selectedDots = [-1];
    this.events = [];
    this.dayEvents = [];
    this.currentTrackVersion = -1;
    this.statusAndRemarks = {};
    this.staticTrackLines = null;
    this.undoStates = [];
    this.redoStates = [];
    this.moving = false;
    this.clicked = false;
    this.dragEnd = false;
    this.editingMode = false;
    this.caterpillarBigMoveKeyCode = 32;
    this.shiftKeyCode = 16;
    this.keysPressed = {};
    this.showRoute = false;
    this.showTrack = true;
    this.showEvents = true;
    this.showRouteInstructions = true;
    this.showStatusAndRemarks = true;
    this.showDayEvents = true;
    this.showAllEvents = true;
    this.routeData = {};
    this.swisstopoHybrid = '';
    this.swisstopoAir = '';
    this.liveViewPolylines = {};
    this.liveViewMarker = {};
    this.currentHighlightedTrack = 'no-track';
    this.MARKER_LAYOUT = 10;
    this.ROUTE_LAYOUT = 3;
    this.EVENT_MARKER_LAYOUT = 11;
    this.REMARKS_MARKER_LAYOUT = 12;
    this.DAY_EVENTS_LAYOUT = 13;
    this.SEARCH_MARKERS_LAYOUT = 14;
    this.INSTRUCTIONS_LAYOUT = 2;
    this.lineToMouseRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.baseLinesRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.routeRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.statusAndRemarksRenderer._drawingContainer.style['pointer-events'] = 'none';
    this.markersContainer = $('#IWOverlay');
    this.traceControlsKeys();
    this.map.getOptions().setArrowKeyAction(window.IWMapOptions.CONTROL_NONE);
    this.pathStyles = {
      "default": {
        main: {
          stroke: '#B5104F',
          strokeWidth: 5,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff',
          strokeWidth: 10,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      done: {
        main: {
          stroke: '#40b534',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      todo: {
        main: {
          stroke: '#d9dd44',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      missed: {
        main: {
          stroke: '#e63d3a',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#fff',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      ConnectError: {
        background: {
          stroke: '#FF0000',
          strokeWidth: 10,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        main: {
          stroke: '#FFF',
          strokeWidth: 5,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeDashStyle: 'dotted'
        }
      }
    };
    this.liveViewPathStyles = {
      "default": {
        main: {
          stroke: '#B5104F',
          strokeWidth: 5,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#000',
          strokeWidth: 4,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      done: {
        main: {
          stroke: '#40b534',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#000',
          strokeWidth: 4,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      todo: {
        main: {
          stroke: '#e63d3a',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#000',
          strokeWidth: 4,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      missed: {
        main: {
          stroke: '#e63d3a',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#000',
          strokeWidth: 4,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      discarded: {
        main: {
          stroke: '#e63d3a',
          strokeWidth: 3,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        background: {
          stroke: '#000',
          strokeWidth: 4,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        }
      },
      ConnectError: {
        background: {
          stroke: '#FF0000',
          strokeWidth: 10,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round'
        },
        main: {
          stroke: '#000',
          strokeWidth: 5,
          strokeOpacity: 1,
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeDashStyle: 'dotted'
        }
      }
    };
    $(document).on('mouseenter', '.IWMarker', function (event) {
      $('<div>', {
        "class": 'dot-information-container',
        text: i18next.t('general.dot-index-count', {
          index: $(event.currentTarget).data('index') + 1,
          total: _this.mapDots.getTotalVisible()
        })
      }).appendTo($('body'));
    });
    $(document).on('mouseleave', '.IWMarker', function () {
      $('.dot-information-container').remove();
    });
    this.markersContainer.on('contextmenu', '.IWMarker', function (event) {
      event.stopPropagation();
      event.preventDefault();
      var contextMenu = window.createContextMenu(parseInt($(event.currentTarget).data('index'), 10));
      contextMenuMousePosition = window.getMousePosition(event);
      $('body').append(contextMenu);
      contextMenu.css({
        left: event.pageX + 'px',
        top: event.pageY + 'px'
      });
      contextMenu.show();
    });
    this.markersContainer.on('mousedown', '.IWMarker', function (event) {
      event.stopPropagation();
      var index = $(event.currentTarget).data('index');
      _this.markerOnMouseDown(index, _this.selectedDots.indexOf(index) !== -1, event);
    });
  }
  return _createClass(FollowmeMap, [{
    key: "changeMapType",
    value: function changeMapType(mapTypeObject) {
      if (!mapTypeObject) return;
      var mapType = this.getMapType(mapTypeObject);
      mapType.setRenderingConfig(window.vectorMapConfig);
      mapType.setMaxLevel(18);
      this.map.setCenter(this.map.getCenter(), this.map.getZoom(), mapType);
      this.showGeometryChanges(window.showGeometry);
      this.map.refreshTiles();
    }
  }, {
    key: "showGeometryChanges",
    value: function showGeometryChanges(show) {
      if (show) {
        var olrString = window.storage.getOlrString();
        this.mergeGeometryChanges(olrString);
      } else {
        this.mergeGeometryChanges('');
      }
    }
  }, {
    key: "mergeGeometryChanges",
    value: function mergeGeometryChanges(detourProfile) {
      var _this2 = this;
      var provider = window.storage.getProvider();
      var aliases;
      if (window.usePostprocessor) {
        aliases = this.map.getOptions().getMapTypeByName('tomtom-latest').getTilesServerConfig().getAliases();
      } else {
        aliases = this.map.getCurrentMapType().getTilesServerConfig().getAliases();
      }
      aliases = aliases.map(function (it) {
        var alias = _this2.removeParameter(it, 'SP_USE');
        alias = _this2.removeParameter(alias, 'MAPPROVIDER');
        return alias + '&SP_USE=' + detourProfile + '&MAPPROVIDER=' + provider;
      });
      if (window.usePostprocessor) {
        this.map.getOptions().getMapTypeByName('tomtom-latest').getTilesServerConfig().setAliases(aliases);
      } else {
        this.map.getCurrentMapType().getTilesServerConfig().setAliases(aliases);
      }
      this.map.refreshTiles();
    }
  }, {
    key: "removeParameter",
    value: function removeParameter(url, parameter) {
      var indexStart = url.indexOf('&' + parameter);
      if (indexStart < 0) {
        return url;
      }
      var indexEnd = url.indexOf('&', indexStart + 1);
      if (indexEnd < 0) {
        return url.substr(0, indexStart);
      }
      return url.substr(0, indexStart) + url.substr(indexEnd);
    }

    /**
     * @function renderTrack Redraws all track
     * @memberOf FollowmeMap
     */
  }, {
    key: "renderTrack",
    value: function renderTrack(color) {
      this.redrawPartly(Object.keys(this.mapDots.get()), color);
    }
  }, {
    key: "getMapType",
    value: function getMapType(mapTypeObject) {
      var mapType = this.map.getOptions().getMapTypeByName(iwconst.DEFAULT_MAPTYPE);
      if (mapTypeObject && mapTypeObject.name === 'HERE_CHL_2019_09') {
        mapType = this.map.getOptions().getMapTypeByName('vector-here-chl-2019.Q3');
      } else if (mapTypeObject && mapTypeObject.name === 'HERE_CHL_2020_12') {
        mapType = this.map.getOptions().getMapTypeByName('vector-here-chl-2020.Q4');
      } else if (mapTypeObject && mapTypeObject.name === 'TomTom_SAM_2019_03') {
        mapType = this.map.getOptions().getMapTypeByName('vector-tomtom-sam-2019.03');
      } else if (mapTypeObject && mapTypeObject.name === 'TomTom_AUS_2019_03') {
        mapType = this.map.getOptions().getMapTypeByName('vector-tomtom-aus-2019.03');
      } else if (mapTypeObject && 'name' in mapTypeObject) {
        mapType = this.map.getOptions().getMapTypeByName(mapTypeObject.name);
      }
      if (!mapType) {
        var mapString = "infoware, ".concat(mapTypeObject.provider, ", Kartendaten ").concat(mapTypeObject.release ? mapTypeObject.release.replace('.', '/') : '');
        mapType = this.map.getOptions().getDynamicMapType(mapTypeObject.name, mapString);
        if (this.map._tileset._vectorTileFactories && this.map._tileset._vectorTileFactories['vectortiles-dynamic']) {
          delete this.map._tileset._vectorTileFactories['vectortiles-dynamic'];
        }
      }
      return mapType;
    }

    /**
     * @function getMapObject Direct access to followme map object
     * @memberOf FollowmeMap
     * @returns {IWMap}
     */
  }, {
    key: "getMapObject",
    value: function getMapObject() {
      return this.map;
    }

    /**
     * @memberOf FollowmeMap
     * @returns {Dots}
     */
  }, {
    key: "getDots",
    value: function getDots() {
      return this.mapDots;
    }

    /**
     * @function toggleTrackDisplay Shows and hides track markers and base lines
     * @memberOf FollowmeMap
     */
  }, {
    key: "toggleTrackDisplay",
    value: function toggleTrackDisplay() {
      this.updateLayoutAndRendererDisplay(this.showTrack, this.MARKER_LAYOUT, this.baseLinesRenderer);
      if (this.staticTrackLines) {
        this.baseLinesRenderer.removeElement(this.staticTrackLines);
        this.staticTrackLines = null;
      }
      if (this.showTrack) {
        this.staticTrackLines = this.redrawBaseLines(this.mapDots, this.baseLinesRenderer, true);
      }
    }

    /**
     * @function toggleDayEventsDisplay Shows and hides day events markers
     * @memberOf FollowmeMap
     */
  }, {
    key: "toggleDayEventsDisplay",
    value: function toggleDayEventsDisplay() {
      this.updateLayoutAndRendererDisplay(this.showDayEvents, this.DAY_EVENTS_LAYOUT);
    }

    /**
     * @function toggleEventsDisplay Shows and hides track events
     * @memberOf FollowmeMap
     */
  }, {
    key: "toggleEventsDisplay",
    value: function toggleEventsDisplay() {
      this.updateLayoutAndRendererDisplay(this.showEvents, this.EVENT_MARKER_LAYOUT);
    }
  }, {
    key: "toggleShowAllEventsDisplay",
    value: function toggleShowAllEventsDisplay() {
      this.redrawPartly(Object.keys(this.mapDots.get()));
    }

    /**
     * @function toggleInstructionsDisplay Shows and hides the instructions
     * @memberOf FollowmeMap
     */
  }, {
    key: "toggleInstructionsDisplay",
    value: function toggleInstructionsDisplay() {
      this.updateLayoutAndRendererDisplay(this.showRouteInstructions, this.INSTRUCTIONS_LAYOUT);
    }

    /**
     * @function toggleStatusAndRemarksDisplay Shows and hides the instructions
     * @memberOf FollowmeMap
     */
  }, {
    key: "updateStatusAndRemarksDisplay",
    value: function updateStatusAndRemarksDisplay() {
      var _this3 = this;
      if (window.statusBGPolyline && window.statusPolyline && window.statusBGPolyline.length > 0 && window.statusPolyline.length > 0) {
        window.statusBGPolyline.forEach(function (poly) {
          poly.attributes.strokeOpacity = _this3.showStatusAndRemarks ? 1 : 0;
        });
        window.statusPolyline.forEach(function (poly) {
          poly.attributes.strokeOpacity = _this3.showStatusAndRemarks ? 1 : 0;
        });
        this.statusAndRemarksRenderer.render();
      }
      this.updateLayoutAndRendererDisplay(this.showStatusAndRemarks, this.REMARKS_MARKER_LAYOUT, this.statusAndRemarksRenderer);
    }

    /**
     * @function updateLayoutAndRendererDisplay Shows and hides layer and renderer
     * @memberOf FollowmeMap
     */
  }, {
    key: "updateLayoutAndRendererDisplay",
    value: function updateLayoutAndRendererDisplay(prop, layerId, renderer) {
      var layer = this.map.getOverlayManager().getLayer(layerId);
      layer.setVisible(prop);
      if (prop) layer.redraw();
      if (renderer) {
        renderer._drawingContainer.style.visibility = prop ? 'visible' : 'hidden';
      }
    }

    /**
     * @function clearMap Deletes all overlays
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearMap",
    value: function clearMap() {
      this.setDots(new _Dots["default"]());
      this.clearTracks();
      this.clearRoute();
      this.clearEvents();
      this.clearInstructions();
      this.clearStatusAndRemarksLayout();
      this.clearSearchMarkers();
    }

    /**
     * @function clearStatusAndRemarksLayout Clears status and remarks info
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearStatusAndRemarksLayout",
    value: function clearStatusAndRemarksLayout() {
      this.statusAndRemarksRenderer.clearContainer();
      this.map.getOverlayManager().removeLayer(this.REMARKS_MARKER_LAYOUT);
    }

    /**
     * @function createDefaultMarker Creates default map marker and sets target coordinates
     * @memberOf FollowmeMap
     * @param {Dot} dot
     * @param color
     * @param colorEvent
     * @returns {window.IWMarker}
     */
  }, {
    key: "createDefaultMarker",
    value: function createDefaultMarker(dot, color, colorEvent) {
      var marker = new window.IWClassMarker(this.map, dot.getCoordinate().toMercator(), 'track-arrow-svg', null, {
        registerEvents: false
      });
      marker.setHotspot(new IWPoint(15, 15));
      var svg = $(window.track_arrow_svg_icon);
      if (typeof color !== 'undefined') {
        svg.find('path').css('fill', color);
      }
      if (dot.hasEvent() && typeof colorEvent !== 'undefined') {
        svg.find('path').css('fill', colorEvent);
      } else if (dot.hasEvent()) {
        svg.find('path').css('fill', '#0a3eaa');
      }
      $(marker._element).html(svg);
      return marker;
    }

    /**
     * @function createCircleMarker Creates circle map marker and sets target coordinates
     * @memberOf FollowmeMap
     * @param {Dot} dot
     * @param {string} color
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createCircleMarker",
    value: function createCircleMarker(dot, color) {
      var marker = new window.IWClassMarker(this.map, dot.getCoordinate().toMercator());
      marker.setHotspot(new window.IWPoint(9, 9));
      marker.setClassName('dot-marker');
      if (color) {
        marker._element.style.backgroundColor = color;
      }
      return marker;
    }

    /**
     * @function createSmallGreyMarker Creates small grey map marker and sets target coordinates
     * @memberOf FollowmeMap
     * @param {Dot} dot
     * @returns {window.IWSimpleMarker}
     */
  }, {
    key: "createSmallGreyMarker",
    value: function createSmallGreyMarker(dot) {
      var markerClass = 'marker-dot-normal';
      if (dot.hasEvent()) {
        markerClass = 'marker-dot-event';
      }
      return new window.IWSimpleMarker(this.map, dot.getCoordinate().toMercator(), markerClass, {
        registerEvents: false,
        size: {
          width: 20,
          height: 20
        }
      });
    }

    /**
     * @function createBigMarker Creates big map marker and sets target coordinates
     * @memberOf FollowmeMap
     * @param {Dot} dot
     * @param color
     * @param colorEvent
     * @returns {window.IWMarker}
     */
  }, {
    key: "createBigMarker",
    value: function createBigMarker(dot, color, colorEvent) {
      var marker = new window.IWClassMarker(this.map, dot.getCoordinate().toMercator(), 'track-arrow-svg-big', null, {
        registerEvents: false
      });
      marker.setHotspot(new IWPoint(20, 20));
      var svg = $(window.track_arrow_svg_icon_big);
      if (typeof color !== 'undefined') {
        svg.find('path').css('fill', color);
      }
      if (dot.hasEvent() && typeof colorEvent !== 'undefined') {
        svg.find('path').css('fill', colorEvent);
      } else if (dot.hasEvent()) {
        svg.find('path').css('fill', '#0a3eaa');
      }
      $(marker._element).html(svg);
      return marker;
    }

    /**
     * @function createRouteInstructionMarker
     * @memberOf FollowmeMap
     * @param {window.IWCoordinate} coordinates
     * @param {string} label String to display
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createRouteInstructionMarker",
    value: function createRouteInstructionMarker(coordinates, label) {
      var marker = new window.IWClassMarker(this.map, coordinates.toMercator(), 'selectedRouteInstructionClass');
      marker.setHotspot(new window.IWPoint(9, 9));
      marker.setContainerClassname('selectedRouteInstructionClass');
      marker.setClassName('dot-route-marker');
      marker.setLabel(label);
      return marker;
    }

    /**
     * @function createRouteInstructionMarker
     * @memberOf FollowmeMap
     * @param {window.IWCoordinate} coordinates
     * @param {string} iconName Icon to display
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createRouteIconMarker",
    value: function createRouteIconMarker(coordinates, iconName) {
      var marker = new window.IWMarker(this.map, coordinates.toMercator());
      var center = new IWPoint(19, 47);
      var size = new IWSize(39, 57);
      var scalableSize = new IWSize(19, 28);
      var scalableSizeCenter = new IWPoint(9, 28);
      if (iconName.indexOf('gps_') !== -1) {
        size = new IWSize(24, 32);
        center = new IWPoint(12, 16);
        scalableSize = new IWSize(12, 16);
        scalableSizeCenter = new IWPoint(6, 8);
      }
      marker.setDefaultIcon(new IWIcon('./img/route-icons/' + iconName, center, size));
      marker.addScaleDependentIcon(new IWScaleDependentIcon('./img/route-icons/' + iconName, scalableSizeCenter, scalableSize, new IWRange(1, 15)));
      return marker;
    }

    /**
     * @function createEventMarker Creates label with selected Event and sets target coordinates
     * @memberOf FollowmeMap
     * @param {window.IWCoordinate} coordinates
     * @param {Event|EventCustom} dotEvent Event info
     * @param {string} markerType Is marker selected or in caterpillar
     * @param {int} dotIndex Index of dot of this event marker
     * @returns {IWClassMarker}
     */
  }, {
    key: "createEventMarker",
    value: function createEventMarker(coordinates, dotEvent, markerType, dotIndex) {
      var _this4 = this;
      var createMarker = function createMarker() {
        // This is a toggle event (Backwards/Forwards) and the event needs to be names accordingly
        // We'll count if this dot is Backwards or Forwards
        var isForwards;
        if (dotEvent.getId() === 65552) {
          for (var i = 0; i < dotIndex; i++) {
            var dot = _this4.mapDots.getByIndex(i);
            if (dot.hasEvent() && dot.getEvent().getId() === 65552) {
              isForwards = !isForwards;
            }
          }
        }
        var eventName;
        if (dotEvent.getId() === 65538) {
          dotEvent._id = 65543;
        }
        if (window.CONSTANTS.DYNAMIC_DEFAULT_EVENTS.includes(dotEvent.getId().toString()) && Object.keys(window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD).includes(dotEvent.getName())) {
          var translationKey = window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD[dotEvent.getName()][dotEvent.getId()];
          if (dotEvent.getId() === 65539) {
            translationKey = 'events.transfer';
          }
          eventName = i18next.t(translationKey);
        }
        if (!eventName && dotEvent.getName().includes("customaction_")) {
          var customAction = dotEvent.getName().split('_')[1];
          if (dotEvent.getId() === 65541) {
            eventName = i18next.t('events.custom-left-side', {
              custom: customAction
            });
          } else if (dotEvent.getId() === 65540) {
            eventName = i18next.t('events.custom-right-side', {
              custom: customAction
            });
          } else if (dotEvent.getId() === 65542) {
            eventName = i18next.t('events.custom-both-sides', {
              custom: customAction
            });
          } else if (dotEvent.getId() === 65543 || id === 65538) {
            eventName = i18next.t('events.custom-no-sides', {
              custom: customAction
            });
          }
        }
        if (!eventName && window.CONSTANTS.LEGACY_DEFAULT_EVENT_TRANSLATIONS.includes(dotEvent.getName())) {
          eventName = window.getEventNameByID(dotEvent.getId());
        }
        if (isForwards) {
          eventName = window.getEventNameByID('065552');
        }
        if (!eventName) {
          eventName = dotEvent.getName();
        }
        if (dotEvent.getName().length >= 35) {
          eventName = dotEvent.getName().substring(0, 35) + '...';
        }
        if (dotEvent.getIsEditable() || dotEvent.getId() === 65555) {
          if (dotEvent.getDescription().length >= 40) {
            eventName += '<small>' + (dotEvent.getDescription().substring(0, 37) + '...') + '</small>';
          } else {
            eventName += '<small>' + dotEvent.getDescription() + '</small>';
          }
        }
        var eventColor = window.getColorCodeFromEventID(dotEvent);
        if (!eventName) {
          eventName = i18next.t('events.' + dotEvent.getId());
          if (eventName === '') {
            eventName = dotEvent.getId();
          }
        }
        var marker = new window.IWClassMarker(_this4.map, coordinates.toMercator(), 'dot-event', eventName, eventColor);
        var markerJQ = $(marker)[0];
        _this4.enableMarkerZoomActions(marker);
        marker.setContainerClassname('dot-event');
        window.enableContextMenu(window.createEventOnDotContextMenu.bind(null, dotIndex, dotEvent), $(marker.getContainer()));
        markerJQ._label.style.borderLeft = '4px solid ' + eventColor;
        markerJQ._label.style.top = 'auto';
        if (markerType === 'small') {
          markerJQ._label.style.bottom = '10px';
        } else if (markerType === 'big') {
          markerJQ._label.style.bottom = '15px';
        } else {
          markerJQ._label.style.bottom = '12px';
        }
        return marker;
      };
      var createCustomMarker = function createCustomMarker() {
        var eventLabel = _this4.getEventCustomLabel(dotEvent);
        var eventColor = dotEvent.getColor() ? dotEvent.getColor() : 'white';
        var marker = new window.IWClassMarker(_this4.map, coordinates.toMercator(), 'dot-event', eventLabel, eventColor);
        var markerJQ = $(marker)[0];
        _this4.enableMarkerZoomActions(marker);
        marker.setContainerClassname('dot-event');
        window.enableContextMenu(window.createEventOnDotContextMenu.bind(null, dotIndex, dotEvent), $(marker.getContainer()));
        markerJQ._label.style.borderLeft = '4px solid ' + eventColor;
        markerJQ._label.style.top = 'auto';
        if (markerType === 'small') {
          markerJQ._label.style.bottom = '11px';
        } else if (markerType === 'big') {
          markerJQ._label.style.bottom = '17px';
        } else {
          markerJQ._label.style.bottom = '14px';
        }
        return marker;
      };
      switch (dotEvent.constructor.name) {
        case 'Event':
          return createMarker();
        case 'EventCustom':
          return createCustomMarker();
        default:
          throw new Error('Event type is not supported');
      }
    }

    /**
     * @function getRawTrackDots Converts map dots to array with Dot
     * @memberOf FollowmeMap
     * @returns {Dot[]}
     */
  }, {
    key: "getRawTrackDots",
    value: function getRawTrackDots(dots) {
      if (!dots) dots = this.mapDots.get();
      return dots.map(this.convertDotToRawDot);
    }
  }, {
    key: "getRawTrackDotsByTrackName",
    value: function getRawTrackDotsByTrackName(trackName) {
      if (!this.editingTracks[trackName]) return [];
      return this.getRawTrackDots(this.editingTracks[trackName].dots.get());
    }

    /**
     * @function convertDotToRawDot Converts dot to raw Dot
     * @memberOf FollowmeMap
     * @returns {Dot}
     */
  }, {
    key: "convertDotToRawDot",
    value: function convertDotToRawDot(d) {
      return {
        hash: d.getHash(),
        lat: d.getLatitude(),
        lon: d.getLongitude(),
        event: d.getEvent(),
        eventType: d.hasEvent() ? d.getEvent().constructor.name : null
      };
    }

    /**
     * @function saveTrackDots Saves track dots to local storage
     * @memberOf FollowmeMap
     * @param {Boolean} [notChanged] Shows is track was not changed. Default to false.
     */
  }, {
    key: "saveTrackDots",
    value: function saveTrackDots(notChanged) {
      var dots = this.getRawTrackDots();
      if (!notChanged) {
        window.storage.trackChanged();
        window.trackManager.saveTrackDots(dots);
      }
    }

    /**
     * @function setTrackStatusAndRemarks Saves track dots to local storage
     * @memberOf FollowmeMap
     * @param {Object} statusAndRemarks
     */
  }, {
    key: "setTrackStatusAndRemarks",
    value: function setTrackStatusAndRemarks(statusAndRemarks) {
      this.statusAndRemarks = statusAndRemarks;
    }

    /**
     * @function assignEventToDots Assigns event to dot
     * @memberOf FollowmeMap
     * @param {string} eventId
     * @param {int} [dotIndex]
     */
  }, {
    key: "assignEventToDots",
    value: function assignEventToDots(eventId, dotIndex) {
      var i;
      var toAssign = dotIndex !== undefined ? [dotIndex] : this.selectedDots;
      this.saveMapState();
      this.redoStates = [];
      var event;
      for (i = 0; i < toAssign.length; i += 1) {
        if (!this.mapDots.getByIndex(toAssign[i])) continue;
        var eventIsDefault = 'defaultEvent' in this.events[eventId] ? this.events[eventId].defaultEvent : false;
        var name = this.events[eventId].name;
        if (window.CONSTANTS.DYNAMIC_DEFAULT_EVENTS.includes(eventId.toString())) {
          name = window.storage.getFollowMeMod();
        }
        if (eventId === 65539 || eventId === "65539") {
          name = "TRANSFER";
        }
        event = new _Event["default"](parseInt(eventIsDefault === true ? this.events[eventId].id : 1, 10), name, this.events[eventId].desc, this.events[eventId].color, eventIsDefault, true);
        this.mapDots.getByIndex(toAssign[i]).setEvent(event);
      }
      this.saveTrackDots();
      this.redrawPartly(toAssign);
      if (eventId === '65555' || eventId === '65553') showModifyInlineEventPopup(toAssign, event);
    }

    /**
     * Looks for the closest dot that has the same event attached to it and it retrieves its values
     *
     * @param dotId
     * @param eventCode
     */
  }, {
    key: "getCustomEventPredefinedValue",
    value: function getCustomEventPredefinedValue(dotId, eventCode) {
      var _this5 = this;
      dotId = dotId || this.selectedDots[0];
      var getEventFromDot = function getEventFromDot(index) {
        var dot = _this5.mapDots.getByIndex(index);
        if (typeof dot === 'undefined') return false;
        if (!dot.hasEvent()) return false;
        var event = dot.getEvent();
        if (event.constructor.name !== 'EventCustom' || event.getId() !== eventCode) return false;
        return event;
      };
      var event;
      var leftResult = null;
      var rightResult = null;

      // check the left
      for (var i = dotId; i >= 0; i--) {
        event = getEventFromDot(i);
        if (!event) continue;
        leftResult = {
          distance: dotId - i,
          event: event
        };
        break;
      }

      // check the right
      for (var j = dotId; j <= this.mapDots.getTotal(); j++) {
        event = getEventFromDot(j);
        if (!event) continue;
        rightResult = {
          distance: j - dotId,
          event: event
        };
        break;
      }
      if (leftResult === null && rightResult === null) return null;
      if (leftResult !== null && rightResult === null) return leftResult.event;
      if (leftResult === null && rightResult !== null) return rightResult.event;
      if (leftResult.distance <= rightResult.distance) return leftResult.event;
      if (leftResult.distance > rightResult.distance) return rightResult.event;
      return null;
    }

    /**
     * @function assignEventToDots Assigns event to dot
     * @memberOf FollowmeMap
     * @param code
     * @param name
     * @param color
     * @param content
     * @param dotId
     */
  }, {
    key: "assignCustomEventToDots",
    value: function assignCustomEventToDots(code, name, color, content, dotId) {
      var toAssign = dotId ? [dotId] : this.selectedDots;
      this.saveMapState();
      this.redoStates = [];
      for (var i = 0; i < toAssign.length; i += 1) {
        var dot = this.mapDots.getByIndex(toAssign[i]);
        if (!dot) continue;
        dot.setEvent(new _EventCustom["default"](parseInt(code, 10), name, content, color, true));
      }
      this.saveTrackDots();
      this.redrawPartly(toAssign);
    }

    /**
     * @function removeEventFromDot Deletes event assigned to dot
     * @memberOf FollowmeMap
     * @param {int} dotIndex
     */
  }, {
    key: "removeEventFromDot",
    value: function removeEventFromDot(dotIndex) {
      this.saveMapState();
      this.mapDots.getByIndex(dotIndex).clearEvent();
      this.saveTrackDots();
      this.redoStates = [];
      this.redrawPartly([dotIndex]);
    }

    /**
     * @function zoomToBounds Zooms map to see all dots
     * @memberOf FollowmeMap
     */
  }, {
    key: "zoomToBounds",
    value: function zoomToBounds(coordinates) {
      var bounds;
      var cords = coordinates;
      if (!coordinates) cords = this.getDotsCoordinates(this.mapDots);
      if (cords.length > 0) {
        bounds = new window.IWBounds(cords);
        this.map.setCenter(bounds.getCenter(), this.map.getBoundsZoomlevel(bounds));
      }
    }

    /**
     * @function zoomToBounds Zooms map to the latest chosen Track (with decreased zoom level)
     * @memberOf FollowmeMap
     */
  }, {
    key: "zoomToBoundsLiveView",
    value: function zoomToBoundsLiveView(coordinates) {
      var bounds;
      var cords = coordinates;
      if (!coordinates) cords = this.getDotsCoordinates(this.mapDots);
      if (cords.length > 0) {
        bounds = new window.IWBounds(cords);
        this.map.setCenter(bounds.getCenter(), this.map.getBoundsZoomlevel(bounds));
      }
    }

    /**
     * @function enableContextMenuForMarker Attaches context menu to marker
     * @memberOf FollowmeMap
     * @param {window.IWClassMarker|window.IWMarker} marker
     * @param {Function} contextMenuFn Function to call on right click
     * @returns {window.IWClassMarker|window.IWMarker}
     */
  }, {
    key: "enableContextMenuForMarker",
    value: function enableContextMenuForMarker(marker, contextMenuFn) {
      this.enableMarkerZoomActions(marker);
      if (contextMenuFn) {
        window.enableContextMenu(contextMenuFn, $(marker.getContainer()));
      }
      return marker;
    }

    /**
     * @function getDotsCoordinates Returns dots coordinates objects from dots
     * @memberOf FollowmeMap
     * @param {Dots} dots
     * @returns {Dot[]}
     */
  }, {
    key: "getDotsCoordinates",
    value: function getDotsCoordinates(dots) {
      return dots.get().filter(function (dot) {
        return dot.isDrawable();
      }).map(function (dot) {
        return dot.getCoordinate();
      });
    }

    /**
     * @function redrawBaseLines Redraws base gray lines between dots
     * @memberOf FollowmeMap
     */
  }, {
    key: "redrawBaseLines",
    value: function redrawBaseLines(dots, renderer, clearContainer) {
      var lineAttributes = {
        stroke: '#6b6b6b',
        strokeWidth: 2,
        strokeOpacity: 1
      };
      if (clearContainer) {
        renderer.clearContainer();
      }
      if (dots.getTotalVisible() < 2) return;
      var staticBaseLines = renderer.drawPolyline(this.getDotsCoordinates(dots), lineAttributes);
      renderer.render();
      return staticBaseLines;
    }

    /**
     * @function updateDotIndexes Updates all the dots indexes
     * @param {Dots} dots
     * @memberOf FollowmeMap
     */
  }, {
    key: "updateDotIndexes",
    value: function updateDotIndexes(dots) {
      dots.get().forEach(function (dot, index) {
        $(dot.getMarker().getContainer()).data('index', index);
      });
    }

    /**
     * Updates dot marker and dot event marker coordinate and rotation
     * @param {number} index
     * @param {number} angle
     * @param {IWCoordinate} coordinate
     */
  }, {
    key: "updateDotMarkers",
    value: function updateDotMarkers(index, angle, coordinate) {
      var dot = this.mapDots.getByIndex(index);
      if (!dot.isDrawable()) return;
      var marker = dot.getMarker();
      marker.setCoordinate(coordinate);
      marker.setRotation(angle);
      marker.redraw();
      if (dot.hasMarkerEvent()) {
        if (dot.getEvent().constructor.name === 'EventCustom') {
          // UPDATE LATITUDE AND LONGITUDE AUTOMATICALLY - CONFLICTS with the the point number on the event
          // dot.getMarkerEvent().setLabel(this.getEventCustomLabel(dot.getEvent()));
        }
        dot.getMarkerEvent().setCoordinate(coordinate);
        dot.getMarkerEvent().redraw();
      }
    }

    /**
     * @function updateAllDotsMarkers Rotates and places markers to new coordinates
     * @memberOf FollowmeMap
     * @param {int[]} changedDots Indexes of changed dots
     */
  }, {
    key: "updateAllDotsMarkers",
    value: function updateAllDotsMarkers(changedDots) {
      var i;
      var index;
      var angle;
      var dotCoordinate;
      var prevDotCoordinate;
      var affectedDots = this.getAffectedDots(changedDots);
      for (index = 1; index < affectedDots.length; index += 1) {
        i = affectedDots[index];
        if (!this.mapDots.getByIndex(i)) return;
        dotCoordinate = this.mapDots.getByIndex(i).getCoordinate();
        prevDotCoordinate = this.mapDots.getByIndex(i - 1).getCoordinate();
        angle = FollowmeMap.getAngle(prevDotCoordinate, dotCoordinate);
        this.updateDotMarkers(i - 1, angle, prevDotCoordinate);
        if (i === this.mapDots.getTotalVisible() - 1) {
          this.updateDotMarkers(i, angle, dotCoordinate);
        }
      }
    }

    /**
     * @function toggleMarkerSelection Add or disables selection for dot
     * @memberOf FollowmeMap
     * @param dotIndex
     */
  }, {
    key: "toggleMarkerSelection",
    value: function toggleMarkerSelection(dotIndex, mouseUpEvent) {
      var indexInSelected;
      var selectedDots = this.selectedDots;
      var changedDots = [dotIndex];
      if (mouseUpEvent.altKey === true) {
        var dot = this.mapDots.getByIndex(dotIndex);
        if (!dot.hasEvent()) return;
        dot.getEvent().setIsDrawable(!dot.getEvent().getIsDrawable());
        this.saveTrackDots();
      }

      // Toggle selection
      if (mouseUpEvent.shiftKey === true) {
        if (selectedDots.length === 0) return;
        var previousSelectedDots = this.selectedDots;
        var startIndex = selectedDots[0];
        var lower = this.selectedDots.some(function (i) {
          return i > dotIndex;
        }) && !this.selectedDots.includes(dotIndex);
        if (lower) {
          startIndex = selectedDots[selectedDots.length - 1];
        }
        selectedDots = [];
        if (dotIndex > startIndex) {
          for (var i = startIndex; i <= dotIndex; i++) {
            selectedDots.push(i);
          }
        } else {
          for (var _i = startIndex; _i >= dotIndex; _i--) {
            selectedDots.push(_i);
          }
          selectedDots.sort();
        }
        this.selectedDots = selectedDots;
        this.highlightTableRows(this.selectedDots);
        this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
        return;

        /*
        indexInSelected = selectedDots.indexOf(parseInt(dotIndex, 10));
         if (indexInSelected !== -1) selectedDots.splice(indexInSelected, 1);
        else selectedDots.push(parseInt(dotIndex, 10));
         selectedDots = selectedDots.sort((a, b) => {
          return a - b;
        });*/
      } else {
        changedDots = changedDots.concat(selectedDots);
        selectedDots = [parseInt(dotIndex, 10)];
      }
      this.selectedDots = selectedDots;
      this.highlightTableRows(this.selectedDots);
      this.redrawPartly(changedDots);
    }

    /**
     * Removes listeners from dots and adds context menu to select track
     * @param {Dots} dots
     * @param trackName
     */
  }, {
    key: "makeTrackDotsStatic",
    value: function makeTrackDotsStatic(dots, trackName) {
      var _this6 = this;
      dots.get().forEach(function (dot, index) {
        if (!dot.isDrawable()) return;
        var marker = dot.getMarker();
        if (!marker) return;
        var markerContainer = marker.getContainer();
        markerContainer.ondragstart = null;
        markerContainer.onmousedown = null;
        markerContainer.onmouseup = window.trackManager.selectTrack.bind(window.trackManager, trackName);
        markerContainer.onmouseover = null;
        markerContainer.onmouseout = null;
        _this6.enableContextMenuForMarker(marker, window.createSelectTrackContextMenu.bind(null, trackName));
      });
    }

    /**
     * Attaches mouse listeners for dot marker
     * @param {Dot} dot
     * @param {int} index
     * @param {int} dotCountIndex
     * @param {int} totalVisibleDots
     */
  }, {
    key: "makeTrackDotActive",
    value: function makeTrackDotActive(dot, index, dotCountIndex, totalVisibleDots) {
      if (!dot.isDrawable()) return;
      var showEvent = !window.followmeMap.showAllEvents ? this.selectedDots.includes(index) : true;
      $(dot.getMarker().getContainer()).data('index', index);
      if (dot.hasEvent() && dot.getEvent().getIsDrawable() && showEvent) {
        var label = $(dot.getMarkerEvent().getContainer()).find('.label');
        var countBox = label.find('.event-bubble-count');
        var text = i18next.t('general.dot-index-count', {
          index: dotCountIndex,
          total: totalVisibleDots
        });
        if (!countBox.length > 0) {
          label.append($('<span>', {
            "class": 'event-bubble-count',
            text: text
          }));
        } else {
          countBox.text(text);
        }
      }
    }
  }, {
    key: "markerOnMouseDown",
    value: function markerOnMouseDown(index, isSelected, mouseDownEvent) {
      var _this7 = this;
      // if not left mouse click exit
      if (mouseDownEvent.which !== 1) return;
      this.saveMapState();
      this.clicked = true;
      var moveDots = function moveDots(dotsIndexes, mapStartPosition, mouseMoveEvent) {
        var j;
        var box;
        var shiftY;
        var shiftX;
        var dotIndex;
        var yTranslate;
        var xTranslate;
        var lonTranslate;
        var latTranslate;
        var movingContainer;
        var x = _this7.dragEnd.pageX - mapStartPosition.left;
        var y = _this7.dragEnd.pageY - mapStartPosition.top;
        var newCoordinate = _this7.map.getCurrentMapType().getProjection().pixelToMeter(new window.IWPoint(x, y)).toWGS84();

        // Calculating real world translation
        lonTranslate = newCoordinate.getX() - _this7.mapDots.getByIndex(index).getLongitude();
        latTranslate = newCoordinate.getY() - _this7.mapDots.getByIndex(index).getLatitude();
        for (j = 0; j < dotsIndexes.length; j += 1) {
          dotIndex = dotsIndexes[j];
          var dot = _this7.mapDots.getByIndex(dotIndex);
          if (!dot.isDrawable()) continue;
          movingContainer = dot.getMarker().getContainer();
          box = movingContainer.getBoundingClientRect();

          // Calculating length to marker center
          shiftY = mouseDownEvent.pageY - box.top + window.pageYOffset;
          shiftX = mouseDownEvent.pageX - box.left + window.pageXOffset;

          // Calculating FE translation
          yTranslate = mouseMoveEvent.pageY - _this7.map._divWindowOverlayY - mapStartPosition.top - shiftY;
          xTranslate = mouseMoveEvent.pageX - _this7.map._divWindowOverlayX - mapStartPosition.left - shiftX;
          movingContainer.style.transform = 'translate(' + xTranslate + 'px,' + yTranslate + 'px)';

          // Save new dot position
          var dotToUpdate = _this7.mapDots.getByIndex(dotIndex);
          dotToUpdate.setLongitude(dotToUpdate.getLongitude() + lonTranslate);
          dotToUpdate.setLatitude(dotToUpdate.getLatitude() + latTranslate);
        }
      };

      // eslint-disable-next-line consistent-return
      document.onmousemove = function (mouseMoveEvent) {
        var mapPosition = _this7.map.getContainer().getBoundingClientRect();
        if (!_this7.clicked) return _this7.mapDots.getByIndex(index).getMarker().getContainer().onmouseup(_this7.dragEnd);
        _this7.moving = true;
        _this7.dragEnd = mouseMoveEvent;
        if (isSelected) {
          moveDots(_this7.selectedDots, mapPosition, mouseMoveEvent);
        } else {
          moveDots([index], mapPosition, mouseMoveEvent);
        }
        _this7.updateAllDotsMarkers(_this7.getAffectedDots(_this7.selectedDots.concat(index)));
        _this7.staticTrackLines = _this7.redrawBaseLines(_this7.mapDots, _this7.baseLinesRenderer, true);
        mouseMoveEvent.stopPropagation();
      };
      document.onmouseup = function (mouseUpEvent) {
        if (!_this7.clicked) return;
        _this7.clicked = false;
        _this7.moving = false;
        // Delete all listeners on move end
        document.onmousemove = null;
        document.onmouseup = null;

        // If not drag and left mouse click - just toggle selection
        if (!_this7.dragEnd && mouseUpEvent.which === 1 && !_this7.editingMode) {
          _this7.dragEnd = null;
          return _this7.toggleMarkerSelection(index, mouseUpEvent);
        }
        _this7.dragEnd = null;

        // Save new dots positions
        _this7.saveTrackDots();
        _this7.redoStates = [];
      };
    }

    /**
     * @function makeTrackDotsActive Allows to move dot or dots within the map
     * @memberOf FollowmeMap
     */
  }, {
    key: "makeTrackDotsActive",
    value: function makeTrackDotsActive(targetDots) {
      var _this8 = this;
      var dotCountIndex = 1;
      var totalVisibleDots = this.mapDots.getTotalVisible();
      this.mapDots.get().forEach(function (dot, index) {
        if (!dot.isDrawable()) return;
        if (!targetDots || targetDots.indexOf(index) !== -1) {
          _this8.makeTrackDotActive(dot, index, dotCountIndex, totalVisibleDots);
        }
        dotCountIndex++;
      });
    }

    /**
     * @function enableMarkerZoomActions zooming map when hover marker
     * @memberOf FollowmeMap
     * @param marker
     */
  }, {
    key: "enableMarkerZoomActions",
    value: function enableMarkerZoomActions(marker) {
      // var self = this;
      // var point;

      /* marker.getContainer().addEventListener('mousewheel', function (event) {
        point = new window.IWPoint(event.layerX, event.layerY);
        if (event.deltaY === 100) self.map.zoom(self.map._zoomLevel - 1, point, false, true);
        if (event.deltaY === -100) self.map.zoom(self.map._zoomLevel + 1, point, false, true);
      }); */
    }

    /**
     * @function setDots Sets track dots
     * @memberOf FollowmeMap
     * @param {Dot[]} dots
     */
  }, {
    key: "setDots",
    value: function setDots(dots) {
      this.mapDots = dots;
      this.selectedDots = [this.mapDots.getTotalVisible() - 1];
      this.saveTrackDots(true);
    }

    /**
     * @function Sets the current version of the loaded track
     * @memberOf FollowmeMap
     * @param {number} version
     */
  }, {
    key: "setCurrentTrackVersion",
    value: function setCurrentTrackVersion(version) {
      this.currentTrackVersion = version;
    }

    /**
     * @function addDot Adds dot to inner dots array
     * @memberOf FollowmeMap
     * @param {Dot} dot
     * @param {Number} [index] Where to insert dot
     */
  }, {
    key: "addDot",
    value: function addDot(dot, index) {
      var indexToInsert = 0;
      if (index) {
        indexToInsert = index;
      } else if (this.selectedDots[this.selectedDots.length - 1] !== -1) {
        indexToInsert = this.selectedDots[this.selectedDots.length - 1] + 1;
      } else if (this.mapDots.getTotal() > 0) {
        indexToInsert = this.mapDots.getTotal();
      }
      var changedDots = this.selectedDots.concat(indexToInsert);
      if (this.selectedDots.length > 1) return;
      this.saveMapState();
      this.redoStates = [];
      this.selectedDots = [indexToInsert];
      this.mapDots.addAtIndex(indexToInsert, new _Dot["default"](parseFloat(dot.lat), parseFloat(dot.lon)));
      this.saveTrackDots();
      this.redrawPartly(changedDots);
    }

    /**
     * @function addDot Adds many to inner dots array
     * @memberOf FollowmeMap
     * @param {Dot[]} dots
     * @param {Number} [index] Where to insert dots
     */
  }, {
    key: "addManyDots",
    value: function addManyDots(dots, index) {
      var indexToInsert = 0;
      if (index) {
        indexToInsert = index;
      } else if (this.selectedDots[this.selectedDots.length - 1] !== -1) {
        indexToInsert = this.selectedDots[this.selectedDots.length - 1] + 1;
      } else if (this.mapDots.getTotal() > 0) {
        indexToInsert = this.mapDots.getTotal();
      }
      var changedDots = this.selectedDots.concat(indexToInsert);
      if (this.selectedDots.length > 1) return;
      this.saveMapState();
      this.redoStates = [];
      this.selectedDots = [];
      for (var i = 0; i < dots.length; i++) {
        var dot = dots[i];
        changedDots.push(indexToInsert + i);
        this.selectedDots.push(indexToInsert + i);
        this.mapDots.addAtIndex(indexToInsert + i, new _Dot["default"](parseFloat(dot.lat), parseFloat(dot.lon), dot.event));
      }
      this.saveTrackDots();
      this.redrawPartly(changedDots);
    }
  }, {
    key: "selectAllDots",
    value: function selectAllDots() {
      this.selectedDots = [];
      for (var i = 0; i < this.mapDots.getTotal(); i++) {
        this.selectedDots.push(i);
      }
      this.redrawPartly(this.selectedDots);
    }
  }, {
    key: "selectFromHere",
    value: function selectFromHere(dot) {
      this.selectFromHereIndex = dot;
      var previousSelectedDots = this.selectedDots;
      this.selectedDots = [dot];
      this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
    }
  }, {
    key: "selectToHere",
    value: function selectToHere(dotIndex) {
      var previousSelectedDots = this.selectedDots;
      var startIndex = this.selectFromHereIndex;
      var selectedDots = [];
      if (dotIndex > startIndex) {
        for (var i = startIndex; i <= dotIndex; i++) {
          selectedDots.push(i);
        }
      } else {
        for (var _i2 = startIndex; _i2 >= dotIndex; _i2--) {
          selectedDots.push(_i2);
        }
        selectedDots.sort();
      }
      this.selectedDots = selectedDots;
      this.highlightTableRows(this.selectedDots);
      this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
      return;
    }

    /**
     * @function getSelectedDots Returns selected dots in raw format
     * @memberOf FollowmeMap
     * @returns {Dot[]}
     */
  }, {
    key: "getSelectedDots",
    value: function getSelectedDots() {
      var _this9 = this;
      return this.selectedDots.map(function (dotIndex) {
        return _this9.convertDotToRawDot(_this9.mapDots.getByIndex(dotIndex));
      });
    }

    /**
     * @function deleteSelectedDots Deletes dot from array trackDots and from map
     * @memberOf FollowmeMap
     * @param {number} dotIndex Indexes to delete
     */
  }, {
    key: "deleteSelectedDots",
    value: function deleteSelectedDots(dotIndex) {
      var _this0 = this;
      var i;
      var dotsIndexesToDelete = this.selectedDots;
      var indexInSelected = dotIndex ? this.selectedDots.indexOf(dotIndex) : 0;
      if (indexInSelected === -1) {
        dotsIndexesToDelete = [dotIndex];
      }
      this.saveMapState();
      this.redoStates = [];
      this.clearTargetDots(this.getAffectedDots(dotsIndexesToDelete));
      this.mapDots.deleteDots(dotsIndexesToDelete);
      if (indexInSelected === -1) {
        for (i = 0; i < this.selectedDots.length; i += 1) {
          if (this.selectedDots[i] > dotIndex) this.selectedDots[i] -= 1;
        }
      } else if (this.selectedDots.length > 1) {
        this.selectedDots = [this.mapDots.getTotal() - 1];
      }
      this.selectedDots = this.selectedDots.filter(function (dot) {
        return _this0.mapDots.getByIndex(dot);
      });
      if (this.selectedDots.length < 1) {
        this.selectedDots = [this.mapDots.getTotal() - 1];
      }
      this.saveTrackDots();
      this.redrawPartly(dotsIndexesToDelete.concat(this.selectedDots));
      this.buildDotTable();
    }

    /**
     * @function getMapState Returns current map state (dots and selections)
     * @memberOf FollowmeMap
     * @returns {object} mapState
     */
  }, {
    key: "getMapState",
    value: function getMapState() {
      return JSON.parse(JSON.stringify({
        trackDots: this.getRawTrackDots(),
        selectedDots: this.selectedDots
      }));
    }

    /**
     * @function Saves current map state and adds it to undo states
     * @memberOf FollowmeMap
     */
  }, {
    key: "saveMapState",
    value: function saveMapState() {
      var mapState = this.getMapState();
      window.trackManager.saveMapState(mapState);
      this.undoStates.push(mapState);
      this.saveTrackDots(true);
    }

    /**
     * @function restoreMapState Restores map state
     * @memberOf FollowmeMap
     * @param {Object} state
     * @param {Dot[]} state.trackDots
     * @param {int[]} state.selectedDots
     * @param {String} color Color for markers
     */
  }, {
    key: "restoreMapState",
    value: function restoreMapState(state, color) {
      var i;
      var trackDots = state.trackDots;
      var maxLength = trackDots.length > this.mapDots.getTotal() ? trackDots.length : this.mapDots.getTotal();
      var changedDots = state.selectedDots.concat(this.selectedDots);
      var newMapDots = [];
      var newDots = {};
      var oldMapDots = {};
      var k;
      for (i = 0; i < maxLength; i += 1) {
        if (trackDots[i]) {
          k = trackDots[i].lat.toString() + trackDots[i].lon.toString();
          if (oldMapDots[k] && trackDots[i].hash === this.mapDots.getByIndex(oldMapDots[k]).getHash()) {
            newMapDots.push(this.mapDots.getByIndex(oldMapDots[k]));
            delete oldMapDots[k];
          } else {
            var dotNew = FollowMeMapUtils.restoreDot(trackDots[i]);
            newMapDots.push(dotNew);
            newDots[k] = i;
          }
        }
        var dot = this.mapDots.getByIndex(i);
        if (dot) {
          k = dot.getLatitude().toString() + dot.getLongitude().toString();
          if (newDots[k] && newMapDots[newDots[k]].getHash() === dot.getHash()) {
            newMapDots[newDots[k]] = dot;
            delete newDots[k];
          } else {
            oldMapDots[k] = i;
          }
        }
      }
      changedDots = changedDots.concat(Object.values(oldMapDots)).concat(Object.values(newDots));
      this.clearTargetDots(this.getAffectedDots(changedDots));
      this.selectedDots = state.selectedDots;
      this.mapDots.replaceWith(newMapDots);
      this.redrawPartly(changedDots, color);
    }

    /**
     * @function undoAction Undo last action
     * @memberOf FollowmeMap
     */
  }, {
    key: "undoAction",
    value: function undoAction() {
      var state = this.undoStates.pop();
      if (!state) return;
      this.redoStates.push(this.getMapState());
      this.restoreMapState(state);
      this.saveTrackDots(true);
    }

    /**
     * @function redoAction Redo last action
     * @memberOf FollowmeMap
     */
  }, {
    key: "redoAction",
    value: function redoAction() {
      var state = this.redoStates.pop();
      if (!state) return;
      this.undoStates.push(this.getMapState());
      this.restoreMapState(state);
      this.saveTrackDots(true);
    }

    /**
     * @function drawLineToCursor Draws gray line from last dot to cursor position
     * @memberOf FollowmeMap
     * @param x
     * @param y
     */
  }, {
    key: "drawLineToCursor",
    value: function drawLineToCursor(x, y) {
      var selectedDot = this.mapDots.getByIndex(this.selectedDots[this.selectedDots.length - 1]);
      var nextDot = this.mapDots.getByIndex(this.selectedDots[this.selectedDots.length - 1] + 1);
      var cursorCoordinate;
      var attributes = {
        stroke: '#818181',
        strokeWidth: 1.5,
        fillOpacity: 1
      };
      if (!selectedDot || !this.showTrack) return;
      cursorCoordinate = this.map.getCurrentMapType().getProjection().pixelToMeter(new window.IWPoint(x, y));
      this.lineToMouseRenderer.clearContainer();
      this.lineToMouseRenderer.drawLine(selectedDot.getCoordinate(), cursorCoordinate, attributes);
      if (nextDot && nextDot.isDrawable()) {
        this.lineToMouseRenderer.drawLine(nextDot.getCoordinate(), cursorCoordinate, attributes);
      }
      this.lineToMouseRenderer.render();
    }
  }, {
    key: "drawSelectPolygon",
    value: function drawSelectPolygon(x, y, coordinates) {
      this.clickedCoordinates = coordinates;
      var cursorCoordinate;
      var attributes = {
        fill: '#7a7a7a',
        stroke: '#000',
        strokeOpacity: 0.6,
        strokeWidth: 2,
        fillOpacity: 0.2
      };
      if (!this.showTrack) return;
      cursorCoordinate = this.map.getCurrentMapType().getProjection().pixelToMeter(new window.IWPoint(x, y));
      this.selectPolygonRenderer.clearContainer();
      this.selectPolygonRenderer.drawPolygon(coordinates, attributes);
      this.selectPolygonRenderer.render();
    }
  }, {
    key: "drawPolygonLineToCursor",
    value: function drawPolygonLineToCursor(x, y) {
      var cursorCoordinate;
      var attributes = {
        fill: '#7a7a7a',
        stroke: '#000',
        strokeOpacity: 0.6,
        strokeWidth: 2,
        fillOpacity: 0.2
      };
      if (!this.showTrack) return;
      cursorCoordinate = this.map.getCurrentMapType().getProjection().pixelToMeter(new window.IWPoint(x, y));
      this.lineToMouseRenderer.clearContainer();
      if (this.clickedCoordinates[0]) this.lineToMouseRenderer.drawLine(this.clickedCoordinates[0], cursorCoordinate, attributes);
      if (this.clickedCoordinates[this.clickedCoordinates.length - 1]) this.lineToMouseRenderer.drawLine(this.clickedCoordinates[this.clickedCoordinates.length - 1], cursorCoordinate, attributes);
      this.selectPolygonRenderer.render();
    }
  }, {
    key: "drawLassoLines",
    value: function drawLassoLines(x, y) {
      var cursorCoordinate;
      cursorCoordinate = this.map.getCurrentMapType().getProjection().pixelToMeter(new window.IWPoint(x, y));
      this.clickedCoordinates.push(cursorCoordinate);
      var attributes = {
        fill: '#7a7a7a',
        stroke: '#000',
        strokeOpacity: 0.6,
        strokeWidth: 2,
        fillOpacity: 0.2
      };
      this.lineToMouseRenderer.clearContainer();
      this.lineToMouseRenderer.drawPolygon(this.clickedCoordinates, attributes);
      this.lineToMouseRenderer.drawLine(this.clickedCoordinates[0], cursorCoordinate, attributes);
      this.lineToMouseRenderer.render();
    }
  }, {
    key: "getDotsInPolygon",
    value: function getDotsInPolygon() {
      var bounds = new IWBounds(this.clickedCoordinates);
      var dotsToSearch = [];
      this.mapDots.get().forEach(function (dot, index) {
        if (bounds.containsCoordinate(dot.getCoordinate().toMercator())) {
          dotsToSearch.push({
            position: index,
            point: [dot.getLongitude(), dot.getLatitude()]
          });
        }
      });
      var polygonPoints = this.clickedCoordinates.map(function (point) {
        return [point.toWGS84().getX(), point.toWGS84().getY()];
      });
      var foundDots = [];
      dotsToSearch.forEach(function (dot) {
        var result = classifyPoint(polygonPoints, dot.point);
        if (result <= 0) foundDots.push(dot.position);
      });
      if (foundDots.length === 0) return;
      var previousSelectedDots = this.selectedDots;
      this.selectedDots = foundDots;
      this.redrawPartly(previousSelectedDots.concat(this.selectedDots));
    }

    /**
     * @function dotToCoordinate Convert dot to IWCoordinate
     * @memberOf FollowmeMap
     * @param {Dot} dot
     * @returns {IWCoordinate}
     */
  }, {
    key: "dotToCoordinate",
    value: function dotToCoordinate(dot) {
      return new window.IWCoordinate(dot.lon, dot.lat, window.IWCoordinate.WGS84);
    }

    /**
     * @function clearLineToCursor Clears lineToMouseRenderer baseLinesRenderer
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearLineToCursor",
    value: function clearLineToCursor() {
      this.lineToMouseRenderer.clearContainer();
    }

    /**
     * @function clearActionHistory Deletes action history from map obj
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearActionHistory",
    value: function clearActionHistory() {
      this.undoStates = [];
      this.redoStates = [];
    }

    /**
     * @function selectNextDot Selects next dot
     * @memberOf FollowmeMap
     */
  }, {
    key: "selectNextDot",
    value: function selectNextDot() {
      var i;
      var targetDotIndex;
      var moveStep = 1;
      var selectedDots = [];
      var lastSelectedDot = this.selectedDots[this.selectedDots.length - 1];
      var changedDots = this.selectedDots.concat(lastSelectedDot + moveStep);
      if (this.moving) return;
      this.saveMapState();
      if (this.keysPressed[this.shiftKeyCode]) {
        targetDotIndex = lastSelectedDot + moveStep;
        if (this.mapDots.getByIndex(targetDotIndex)) this.selectedDots.push(targetDotIndex);
        this.redrawPartly(changedDots);
        return;
      }
      if (this.keysPressed[this.caterpillarBigMoveKeyCode] === true) {
        moveStep = 10;
        changedDots.push(lastSelectedDot + moveStep);
      }
      for (i = 0; i < this.selectedDots.length; i += 1) {
        targetDotIndex = this.selectedDots[i] + moveStep;
        if (this.mapDots.getByIndex(targetDotIndex)) selectedDots.push(targetDotIndex);
      }
      if (selectedDots.length === 0) selectedDots = [this.mapDots.getTotal() - 1];
      this.selectedDots = selectedDots;
      this.redrawPartly(changedDots);
    }

    /**
     * @function selectPreviousDot Selects previous dot
     * @memberOf FollowmeMap
     */
  }, {
    key: "selectPreviousDot",
    value: function selectPreviousDot() {
      var i;
      var targetDotIndex;
      var selectedDots = [];
      var moveStep = 1;
      var changedDots = this.selectedDots.concat(this.selectedDots[0] - moveStep);
      if (this.moving) return;
      this.saveMapState();
      if (this.keysPressed[this.shiftKeyCode]) {
        targetDotIndex = this.selectedDots[0] - moveStep;
        if (this.mapDots.getByIndex(targetDotIndex)) this.selectedDots.unshift(targetDotIndex);
        this.redrawPartly(changedDots);
        return;
      }
      if (this.keysPressed[this.caterpillarBigMoveKeyCode] === true) {
        moveStep = 10;
        changedDots.push(this.selectedDots[0] - moveStep);
      }
      for (i = 0; i < this.selectedDots.length; i += 1) {
        targetDotIndex = this.selectedDots[i] - moveStep;
        if (this.mapDots.getByIndex(targetDotIndex)) selectedDots.push(targetDotIndex);
      }
      if (selectedDots.length === 0) selectedDots = [0];
      this.selectedDots = selectedDots;
      this.redrawPartly(changedDots);
    }

    /**
     * @function traceControlsKeys Traces controls keys down/up. Used for selection manipulation
     * @memberOf FollowmeMap
     */
  }, {
    key: "traceControlsKeys",
    value: function traceControlsKeys() {
      var self = this;
      document.addEventListener('keydown', function (ev) {
        self.keysPressed[ev.keyCode] = true;
      });
      document.addEventListener('keyup', function (ev) {
        delete self.keysPressed[ev.keyCode];
      });
    }

    /**
     * @function setEvents Saves events data
     * @memberOf FollowmeMap
     * @param events
     */
  }, {
    key: "setEvents",
    value: function setEvents(events) {
      var i;
      this.events = {};
      for (i = 0; i < events.length; i += 1) {
        this.events[events[i].id] = events[i];
      }
    }

    /**
     * @function clearEvents Clears events renderer
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearEvents",
    value: function clearEvents() {
      this.map.getOverlayManager().removeLayer(this.EVENT_MARKER_LAYOUT);
    }

    /**
     * @function clearInstructions Clears instructions layer
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearInstructions",
    value: function clearInstructions() {
      this.map.getOverlayManager().removeLayer(this.INSTRUCTIONS_LAYOUT);
    }

    /**
     * @function clearTracks Clears track renderer
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearTracks",
    value: function clearTracks() {
      this.baseLinesRenderer.clearContainer();
      this.map.getOverlayManager().removeLayer(this.MARKER_LAYOUT);
    }

    /**
     * @function clearRoute Clears route renderer
     * @memberOf FollowmeMap
     */
  }, {
    key: "clearRoute",
    value: function clearRoute() {
      this.routeRenderer.clearContainer();
      this.map.getOverlayManager().removeLayer(this.ROUTE_LAYOUT);
    }

    /**
     * @function renderRoute Renders calculated route of track
     * @memberOf FollowmeMap
     * @param {Object} routeData Response from calculatePostedRoute
     */
  }, {
    key: "renderRoute",
    value: function renderRoute(routeData) {
      var _this1 = this;
      var i;
      var j;
      var coordinates = [];
      var coordinatesWithColor = {};
      var impracticableCoordinates = [];
      var features;
      var marker;
      var translator = new _InstructionsTranslator["default"](i18next.languages[0]);
      if (!routeData || !routeData.features) return;
      features = routeData.features;
      this.routeData = routeData;
      this.clearRoute();
      var instructionIndex = 0;
      for (i = 0; i < features.length; i += 1) {
        var feature = features[i];
        switch (feature.geometry.type) {
          case 'LineString':
            {
              if (!this.showRoute) break;
              var isSpecialCase = false;
              var specialCaseCoordinates = [];
              if ('TYPE' in feature.properties && feature.properties.TYPE === 'ConnectError') {
                isSpecialCase = true;
              }
              for (j = 0; j < feature.geometry.coordinates.length; j += 1) {
                var segment = new window.IWCoordinate(feature.geometry.coordinates[j][0], feature.geometry.coordinates[j][1]);
                if (isSpecialCase) {
                  specialCaseCoordinates.push(segment);
                } else {
                  if (!coordinatesWithColor[feature.properties.COLOR]) coordinatesWithColor[feature.properties.COLOR] = {};
                  if (!coordinatesWithColor[feature.properties.COLOR][i]) coordinatesWithColor[feature.properties.COLOR][i] = [];
                  coordinatesWithColor[feature.properties.COLOR][i].push(segment);
                  coordinates.push(segment);
                }
              }
              if (isSpecialCase) {
                impracticableCoordinates.push(specialCaseCoordinates);
              }
              break;
            }
          case 'Point':
            {
              if (!this.showRoute || !feature.properties || !(feature.properties.TEXT || feature.properties.ICONNAME)) break;
              if (feature.properties.TEXT) {
                instructionIndex++;
                marker = this.createRouteInstructionMarker(new window.IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1]), instructionIndex + ': ' + translator.getTranslationForText(feature.properties.TEXT));
              }
              if (feature.properties.ICONNAME) {
                marker = this.createRouteIconMarker(new window.IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1]), feature.properties.ICONNAME);
              }
              this.map.getOverlayManager().getLayer(this.INSTRUCTIONS_LAYOUT).addOverlay(marker);
              break;
            }
          default:
            console.warn('Unsupported geometry type');
            break;
        }
      }
      this.map.getOverlayManager().getLayer(this.INSTRUCTIONS_LAYOUT).setVisible(this.showRouteInstructions);
      this.routeRenderer.drawPolyline(coordinates, this.pathStyles["default"].background);
      //this.routeRenderer.drawPolyline(coordinates, this.pathStyles.default.main);
      Object.keys(coordinatesWithColor).forEach(function (key) {
        Object.keys(coordinatesWithColor[key]).forEach(function (index) {
          if (key === '#ffffff00' || key === 'route') {
            _this1.routeRenderer.drawPolyline(coordinatesWithColor[key][index], _this1.pathStyles["default"].main);
          } else if (key === 'ccTransfer') {
            var options = {
              stroke: '#ffff00',
              strokeWidth: 5,
              strokeOpacity: 1,
              strokeLinejoin: 'round',
              strokeLinecap: 'round'
            };
            _this1.routeRenderer.drawPolyline(coordinatesWithColor[key][index], options);
          } else {
            var _options = {
              stroke: key,
              strokeWidth: 5,
              strokeOpacity: 1,
              strokeLinejoin: 'round',
              strokeLinecap: 'round'
            };
            _this1.routeRenderer.drawPolyline(coordinatesWithColor[key][index], _options);
          }
        });
      });

      //this.routeRenderer.drawPolyline(coordinates, this.pathStyles.default.main);

      if (impracticableCoordinates.length > 0) {
        impracticableCoordinates.forEach(function (impracticableCoordinate) {
          _this1.routeRenderer.drawPolyline(impracticableCoordinate, _this1.pathStyles.ConnectError.background);
          _this1.routeRenderer.drawPolyline(impracticableCoordinate, _this1.pathStyles.ConnectError.main);
        });
      }
      this.routeRenderer.render();
    }

    /**
     * @function removeTargetMarker Removes target overlay from target layer
     * @memberOf FollowmeMap
     * @param {int} layerId
     * @param {int} overlayId
     */
  }, {
    key: "removeTargetMarker",
    value: function removeTargetMarker(layerId, overlayId) {
      var layer = this.map.getOverlayManager().getLayer(layerId);
      var overlay;
      if (!layer || !layer.getOverlayById(overlayId)) return;
      overlay = layer.getOverlayById(overlayId);
      if (!overlay) return;
      layer.removeOverlay(overlay);
    }

    /**
     * @function isDefaultMarker Returns true if target index around selected dot
     * @memberOf FollowmeMap
     * @param {int} index
     * @returns {boolean} Is default marker
     */
  }, {
    key: "isDefaultMarker",
    value: function isDefaultMarker(index) {
      var i;
      if (this.selectedDots.indexOf(index) !== -1) return false;
      for (i = 0; i < this.selectedDots.length; i += 1) {
        if (index >= this.selectedDots[i] - 10 && index <= this.selectedDots[i] + 3) return true;
      }
      return false;
    }

    /**
     * @function redrawMarker Deletes previous dot marker and draws new
     * @memberOf FollowmeMap
     * @param {int} i Dot index
     * @param {boolean} forcedRotate Is marker needs to be rotated to next dot
     * @param {string} color Is marker needs to be rotated to next dot
     */
  }, {
    key: "redrawMarker",
    value: function redrawMarker(i, forcedRotate, color) {
      var angle;
      var marker;
      var markerType;
      var dot = this.mapDots.getByIndex(i);
      var id = '_' + Math.random().toString(36).substr(2, 9);
      if (this.mapDots.getTotalVisible() === 1) {
        marker = this.createCircleMarker(dot, color);
      } else if (this.selectedDots.indexOf(i) !== -1) {
        marker = this.createBigMarker(dot, color);
        markerType = 'big';
      } else if (this.isDefaultMarker(i) && this.selectedDots.length === 1) {
        marker = this.createDefaultMarker(dot, color);
        markerType = 'default';
      } else {
        marker = this.createSmallGreyMarker(dot);
        markerType = 'small';
      }
      marker.setId(id);
      this.map.getOverlayManager().getLayer(this.MARKER_LAYOUT).addOverlay(marker);
      var showEvent = !window.followmeMap.showAllEvents ? this.selectedDots.includes(i) : true;
      if (dot.hasEvent() && dot.getEvent().getIsDrawable() && showEvent) {
        var markerEvent = this.createEventMarker(dot.getCoordinate(), dot.getEvent(), markerType, i);
        markerEvent.setId(id);
        markerEvent.setCoordinate(dot.getCoordinate());
        this.map.getOverlayManager().getLayer(this.EVENT_MARKER_LAYOUT).addOverlay(markerEvent);
        dot.setMarkerEvent(markerEvent);
      } else {
        delete dot.clearMarkerEvent();
      }
      var previousDot = this.mapDots.getByIndex(i - 1);
      if (previousDot && previousDot.hasMarker()) {
        angle = FollowmeMap.getAngle(previousDot.getCoordinate(), dot.getCoordinate());
        previousDot.getMarker().setRotation(angle);
        previousDot.getMarker().redraw();
      }
      if (forcedRotate) {
        if (this.mapDots.getByIndex(i + 1)) {
          angle = FollowmeMap.getAngle(dot.getCoordinate(), this.mapDots.getByIndex(i + 1).getCoordinate());
        }
        if (this.mapDots.getTotalVisible() > 1) marker.setRotation(angle);
        marker.redraw();
      }
      if (this.editingMode) {
        marker.getContainer().style['pointer-events'] = 'none';
        if (dot.hasMarkerEvent()) dot.getMarkerEvent().getContainer().style['pointer-events'] = 'none';
      }
      dot.setMarker(marker);
    }

    /**
     * @function getAffectedDots Returns array of affected dots. Dots around changed
     * @memberOf FollowmeMap
     * @param {Array} changedDots
     * @returns {int[]}
     */
  }, {
    key: "getAffectedDots",
    value: function getAffectedDots(changedDots) {
      var i;
      var map = {};
      changedDots = changedDots.map(function (d) {
        return parseInt(d, 10);
      });
      return changedDots.reduce(function (array, dot) {
        for (i = dot - 11; i <= dot + 3; i += 1) {
          if (map[i] || i < 0) continue;
          map[i] = true;
          array.push(i);
        }
        return array;
      }, []).sort(function (a, b) {
        return a - b;
      });
    }

    /**
     * @function deleteDotMarkers Deletes event marker and dot marker for dot
     * @memberOf FollowmeMap
     * @param {Dot} dot
     */
  }, {
    key: "deleteDotMarkers",
    value: function deleteDotMarkers(dot) {
      if (!dot) return;
      if (dot.hasMarkerEvent()) this.removeTargetMarker(this.EVENT_MARKER_LAYOUT, dot.getMarkerEvent().getId());
      if (dot.hasMarker()) this.removeTargetMarker(this.MARKER_LAYOUT, dot.getMarker().getId());
      dot.clearMarker();
      dot.clearMarkerEvent();
    }

    /**
     * @function Deletes markers of target dots
     * @memberOf FollowmeMap
     * @param {int[]} affectedDots
     */
  }, {
    key: "clearTargetDots",
    value: function clearTargetDots(affectedDots) {
      var j;
      var i;
      for (j = 0; j < affectedDots.length; j += 1) {
        i = affectedDots[j];
        if (this.mapDots.getByIndex(i)) this.deleteDotMarkers(this.mapDots.getByIndex(i));
      }
    }

    /**
     * Deletes track markers and redraws base lines
     * @param {string} trackName
     */
  }, {
    key: "eraseTrack",
    value: function eraseTrack(trackName) {
      if (!this.editingTracks[trackName]) return;
      this.editingTracks[trackName].dots._dots.map(this.deleteDotMarkers.bind(this));
      delete this.editingTracks[trackName];
      this.redrawStaticTracksLines();
    }

    /**
     * Changes track makers pointer to a new name
     * @param {string} oldName
     * @param {String} newName
     */
  }, {
    key: "updateTrackName",
    value: function updateTrackName(oldName, newName) {
      var trackRender = this.editingTracks[oldName];
      if (!trackRender) throw new Error('Track with name ' + oldName + ' is not under edit');
      delete this.editingTracks[oldName];
      this.editingTracks[newName] = trackRender;
    }

    /**
     * Redraws lines for not editing tracks
     */
  }, {
    key: "redrawStaticTracksLines",
    value: function redrawStaticTracksLines() {
      var _this10 = this;
      var currentTrackName = window.storage.getTrackInfo().trackName;
      Object.keys(followmeMap.editingTracks).forEach(function (tn) {
        if (tn === currentTrackName) return;
        _this10.staticTrackLines = _this10.redrawBaseLines(_this10.editingTracks[tn].dots, _this10.baseLinesRenderer);
      });
    }

    /**
     * @function Redraws changed dots in current track
     * @memberOf FollowmeMap
     * @param {int[]} changedDots
     * @param {string} color Marker colors
     */
  }, {
    key: "redrawPartly",
    value: function redrawPartly(changedDots, color) {
      var _this11 = this;
      this.drawing = true;
      if (!color) {
        if (window.storage.isTestMode()) {
          color = window.storage.getTestTrack().color;
        } else {
          color = window.storage.getTrackInfo().color;
        }
      }
      var affectedDots = this.getAffectedDots(changedDots);
      this.clearTargetDots(affectedDots);
      this.mapDots.get().forEach(function (dot, index) {
        if (!dot.isDrawable() || dot.hasMarker() && affectedDots.indexOf(index) === -1) return;
        var nextIndex = index + 1;
        var forceRotate = nextIndex !== affectedDots[nextIndex] || !_this11.mapDots.getByIndex(nextIndex);
        _this11.redrawMarker(index, forceRotate, color);
      });
      this.makeTrackDotsActive(affectedDots);
      this.staticTrackLines = this.redrawBaseLines(this.mapDots, this.baseLinesRenderer, true);
      this.updateDotIndexes(this.mapDots);
      if (!this.showTrack) this.toggleTrackDisplay();
      this.drawing = false;
    }

    /**
     * @function disableMarkersPointerEvents Disables markers pointer events
     * @memberOf FollowmeMap
     * @param {Boolean} [forced] If not forced and already in editing mode method will not be applied
     */
  }, {
    key: "disableMarkersPointerEvents",
    value: function disableMarkersPointerEvents(forced) {
      var i;
      var overlays;
      if (this.editingMode && !forced) return;
      this.editingMode = true;
      overlays = this.map.getOverlayManager().getLayer(this.MARKER_LAYOUT).getOverlays().concat(this.map.getOverlayManager().getLayer(this.EVENT_MARKER_LAYOUT).getOverlays());
      for (i = 0; i < overlays.length; i += 1) {
        overlays[i].getContainer().style['pointer-events'] = 'none';
      }
    }

    /**
     * @function enableMarkersPointerEvents Enables pointer events for markers
     * @memberOf FollowmeMap
     */
  }, {
    key: "enableMarkersPointerEvents",
    value: function enableMarkersPointerEvents() {
      var i;
      var overlays;
      this.editingMode = false;
      overlays = this.map.getOverlayManager().getLayer(this.MARKER_LAYOUT).getOverlays().concat(this.map.getOverlayManager().getLayer(this.EVENT_MARKER_LAYOUT).getOverlays());
      for (i = 0; i < overlays.length; i += 1) {
        overlays[i].getContainer().style['pointer-events'] = 'all';
      }
    }

    /**
     * Restores the track based on a plain text object representation
     *
     * @param {Array} rawDots
     * @param {String} color Color for makers
     * @return {Dots} track dots
     */
  }, {
    key: "restoreTrack",
    value: function restoreTrack(rawDots, color) {
      var dots;
      if (rawDots.constructor.name === 'Dots') {
        dots = rawDots;
      } else {
        dots = new _Dots["default"]();
        rawDots.forEach(function (dot) {
          dots.add(FollowMeMapUtils.restoreDot(dot));
        });
      }
      this.setDots(dots);
      this.renderTrack(color);
      this.zoomToBounds();
      return dots;
    }

    /**
     * Formula for bearing on a rhumb line (https://en.wikipedia.org/wiki/Rhumb_line):
     *
     * Δψ = ln( tan(π/4 + φ2/2) / tan(π/4 + φ1/2) ) ----> ("projected" latitude difference)
     * θ = atan2(Δλ, Δψ)
     * - where φ is latitude, λ is longitude, Δλ is taking shortest route (<180°), R is the earth’s radius, ln is natural log
     *
     * @param cord1
     * @param cord2
     * @returns {number}
     * @static
     */
  }, {
    key: "updateInlineEvent",
    value:
    /**
     * Updates an event on the map after the user has modified it inline
     *
     * @param {number} dotIndex
     * @param {number} eventId
     * @param {string} eventName
     * @param {string} eventDescription
     * @param {string} eventColor
     *
     * @return {void}
     */
    function updateInlineEvent(dotIndex, eventId, eventName, eventDescription, eventColor) {
      this.saveMapState();
      var dot = this.mapDots.getByIndex(dotIndex);
      var oldEvent = dot.getEvent();
      dot.setEvent(new _Event["default"](oldEvent.getId(), eventName, eventDescription, eventColor, oldEvent.getIsDefault(), true));
      this.saveTrackDots();
      this.redrawPartly([dotIndex]);
    }

    /**
     * Retrieves a list of events definitions, if any
     *
     * @return {Object}
     */
  }, {
    key: "getEventCustomDefinition",
    value: function getEventCustomDefinition() {
      return this.mapDots.getDefinitions();
    }
  }, {
    key: "getEventCustomLabel",
    value: function getEventCustomLabel(event) {
      var label = event.getName();
      var content = event.getContent();
      Object.keys(content).forEach(function (item) {
        if (!(item in content) || content[item] === null) return;
        label += '<small><strong>' + getCustomEventAttribute(item) + '</strong>: ' + content[item] + '</small>';
      });
      return label;
    }

    /**
     * Iterates through each of the dots with events and checks if the event is present on at least one dot
     *
     * @param eventId
     */
  }, {
    key: "dotHasCustomEventAssigned",
    value: function dotHasCustomEventAssigned(eventId) {
      return this.mapDots.get().some(function (dot) {
        if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustom') return false;
        return dot.getEvent().getId() === eventId;
      });
    }

    /**
     * Creates general IWClassMarker
     * @param coordinates
     * @param {string} label
     * @param {string} color
     * @param {string} classes Classes to add to marker element
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createGeneralMarker",
    value: function createGeneralMarker(coordinates, label, color, classes) {
      classes = classes || '';
      var marker = new window.IWClassMarker(this.map, coordinates.toMercator(), 'dot-event ' + classes, label, color);
      var markerElement = $(marker)[0];
      this.enableMarkerZoomActions(marker);
      marker.setContainerClassname('dot-event ' + classes);
      markerElement._label.style.borderLeft = '4px solid ' + color;
      markerElement._label.style.top = 'auto';
      markerElement._label.style.bottom = '14px';
      return marker;
    }

    /**
     * @function createRouteRemarkMarker
     * @memberOf FollowmeMap
     * @param {window.IWCoordinate} coordinates
     * @param {string} label Label to display
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createRouteRemarkMarker",
    value: function createRouteRemarkMarker(coordinates, label) {
      return this.createGeneralMarker(coordinates, label, 'white', 'dot-remark');
    }

    /**
     * @function createSearchMarker
     * @memberOf FollowmeMap
     * @param {window.IWCoordinate} coordinates
     * @param {string} label Label to display
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "renderSearchMarker",
    value: function renderSearchMarker(coordinates, label) {
      var marker = this.createGeneralMarker(coordinates, label, 'white', 'dot-search');
      this.map.getOverlayManager().removeLayer(this.SEARCH_MARKERS_LAYOUT);
      this.map.getOverlayManager().getLayer(this.SEARCH_MARKERS_LAYOUT).addOverlay(marker);
    }

    /**
     * Removes search markers layer
     */
  }, {
    key: "clearSearchMarkers",
    value: function clearSearchMarkers() {
      this.map.getOverlayManager().removeLayer(this.SEARCH_MARKERS_LAYOUT);
    }

    /**
     * Sets and renders status and remarks, considering current visibility state
     * @param statusAndRemarks
     */
  }, {
    key: "restoreStatusAndRemarks",
    value: function restoreStatusAndRemarks(statusAndRemarks) {
      this.setTrackStatusAndRemarks(statusAndRemarks);
      this.renderStatusAndRemarks(statusAndRemarks, true);
      this.updateStatusAndRemarksDisplay();
    }

    /**
     * Renders status and remarks
     * @param {object} statusAndRemarks
     * @param {object} statusAndRemarks.remarks
     * @param {object} statusAndRemarks.status
     * @param {boolean} forced Force render
     */
  }, {
    key: "renderStatusAndRemarks",
    value: function renderStatusAndRemarks(statusAndRemarks, forced) {
      statusAndRemarks = statusAndRemarks || this.statusAndRemarks;
      if (!forced && (!this.showStatusAndRemarks || !statusAndRemarks)) return;
      this.clearStatusAndRemarksLayout();
      this.renderRemarks(statusAndRemarks.remarks);
      this.renderStatus(statusAndRemarks.status);
    }

    /**
     * @function createDayEventMarker
     * @memberOf FollowmeMap
     * @param {DayEvent} dayEvent
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createDayEventMarker",
    value: function createDayEventMarker(dayEvent) {
      var marker = this.createGeneralMarker(dayEvent.coordinates, dayEvent.name, 'white', 'dot-day-event');
      var markerElement = $(marker)[0];
      var availabilityText = 'Always';
      window.enableContextMenu(window.createDayEventsContextMenu.bind(null, dayEvent.name), $(marker.getContainer()));
      switch (dayEvent.type) {
        case 'dayofweek':
          {
            availabilityText = dayEvent.weekday;
            break;
          }
        case 'fromto':
          {
            availabilityText = 'FROM ' + formatDayEventDate(dayEvent.fromDate) + ' TO ' + formatDayEventDate(dayEvent.toDate);
            break;
          }
        default:
          break;
      }
      var labelContent = '<div>' + dayEvent.name + '</div>' + '<div class="fontsize-x-small availability">' + availabilityText + '</div>';
      var labelElement = $(markerElement._label);
      labelElement.html(labelContent);
      labelElement.find('div ').attr('title', dayEvent.name);
      return marker;
    }

    /**
     * @function createRouteRemarkMarker
     * @memberOf FollowmeMap
     * @param {window.IWCoordinate} coordinates
     * @param {string} label Label to display
     * @returns {window.IWClassMarker}
     */
  }, {
    key: "createStatusMarker",
    value: function createStatusMarker(coordinates, label) {
      return this.createGeneralMarker(coordinates, label, '#0004ff', 'dot-status-marker');
    }
  }, {
    key: "renderDayEvent",
    value: function renderDayEvent(dayEvent) {
      var marker = this.createDayEventMarker(dayEvent);
      this.map.getOverlayManager().getLayer(this.DAY_EVENTS_LAYOUT).addOverlay(marker);
    }
  }, {
    key: "clearDayEvents",
    value: function clearDayEvents() {
      this.map.getOverlayManager().removeLayer(this.DAY_EVENTS_LAYOUT);
    }
  }, {
    key: "renderDayEvents",
    value: function renderDayEvents(dayEvents) {
      dayEvents = dayEvents || this.dayEvents;
      this.clearDayEvents();
      dayEvents.map(this.renderDayEvent.bind(this));
    }
  }, {
    key: "setDayEvents",
    value: function setDayEvents(dayEvents) {
      this.dayEvents = dayEvents;
    }
  }, {
    key: "addDayEvent",
    value: function addDayEvent(dayEvent) {
      this.dayEvents.push(dayEvent);
      this.renderDayEvent(dayEvent);
    }
  }, {
    key: "renderRemarks",
    value: function renderRemarks(pathData) {
      if (!this.showStatusAndRemarks || !pathData || !pathData.features) return;
      var i;
      var features;
      var marker;
      features = pathData.features;
      for (i = 0; i < features.length; i += 1) {
        var feature = features[i];
        switch (feature.geometry.type) {
          case 'Point':
            {
              if (!feature.properties || !feature.properties.TEXT) break;
              var label = feature.properties.TEXT;
              marker = this.createRouteRemarkMarker(new window.IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1]), label);
              this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).addOverlay(marker);
              break;
            }
          default:
            console.warn('Unsupported geometry type');
            break;
        }
      }
      this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).setVisible(this.showStatusAndRemarks);
    }
  }, {
    key: "highlightLiveViewRoute",
    value: function highlightLiveViewRoute(trackName) {
      var polylines = this.liveViewPolylines[trackName];
      if (typeof polylines === 'undefined') return;
      this.currentHighlightedTrack = trackName;
      polylines.forEach(function (polyline) {
        polyline.attributes.strokeWidth = 7;
      });
      this.statusAndRemarksRenderer.render();
    }
  }, {
    key: "removeHighlightFromLiveViewRoute",
    value: function removeHighlightFromLiveViewRoute(trackName) {
      var polylines = this.liveViewPolylines[trackName];
      this.currentHighlightedTrack = 'no-track';
      if (typeof polylines === 'undefined') return;
      polylines.forEach(function (polyline) {
        polyline.attributes.strokeWidth = 3;
      });
      this.statusAndRemarksRenderer.render();
    }
  }, {
    key: "deleteLiveViewPolyline",
    value: function deleteLiveViewPolyline(trackName) {
      var polylines = this.liveViewPolylines[trackName];
      var renderer = this.statusAndRemarksRenderer;
      var marker = this.liveViewMarker[trackName];
      polylines.forEach(function (polyline) {
        renderer.removeElement(polyline);
      });
      this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).removeOverlay(marker);
      delete this.liveViewPolylines[trackName];
      renderer.render();
    }
  }, {
    key: "renderStatusForLiveView",
    value: function renderStatusForLiveView(pathData, trackName) {
      var i;
      var j;
      var features;
      var path = [];
      var renderer = this.statusAndRemarksRenderer;
      var styles = this.liveViewPathStyles;
      if (!pathData || !pathData.features || !this.showStatusAndRemarks) return;
      features = pathData.features;

      // renderer.clearContainer();

      for (i = 0; i < features.length; i += 1) {
        var feature = features[i];
        var segment = {
          type: feature.properties.TYPE || 'default',
          coordinates: []
        };
        switch (feature.geometry.type) {
          case 'LineString':
            for (j = 0; j < feature.geometry.coordinates.length; j += 1) {
              var point = new window.IWCoordinate(feature.geometry.coordinates[j][0], feature.geometry.coordinates[j][1]);
              segment.coordinates.push(point);
            }
            break;
          case 'Point':
            {
              if (!feature.properties || !feature.properties.STATE) break;

              // if(feature.properties.STATE === "finished") removeLiveSpanFromTrackList(trackName);

              var icon = new IWIcon('./img/icons/car-top.svg', new window.IWPoint(10, 18), new window.IWSize(20, 36));
              var marker = new IWMarker(this.map, new window.IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1]));
              marker.setDefaultIcon(icon);
              this.liveViewMarker[trackName] = marker;
              this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).addOverlay(marker);
              break;
            }
          default:
            console.debug('Unsupported geometry type');
            break;
        }
        path.push(segment);
      }
      var polylines = [];
      var doneSegements = [];
      var todoSegments = [];
      var keys = Object.keys(path);
      for (i = keys.length - 1; i >= 0; i--) {
        var _segment = path[i];
        var style = styles[_segment.type] || styles["default"];
        if (_segment.type === 'done') {
          doneSegements.push(_segment);
        } else {
          todoSegments.push(_segment);
        }

        // polylines.push(renderer.drawPolyline(segment.coordinates, style.background));
        // polylines.push(renderer.drawPolyline(segment.coordinates, style.main));
      }
      polylines = this.renderDoneStatusLiveView(doneSegements, renderer).concat(this.renderTodoStatusLiveView(todoSegments, renderer));
      this.liveViewPolylines[trackName] = polylines;
      renderer.render();
    }
  }, {
    key: "renderDoneStatusLiveView",
    value: function renderDoneStatusLiveView(segments, renderer) {
      var polylines = [];
      var styles = this.liveViewPathStyles;
      segments.forEach(function (segment) {
        var style = styles[segment.type] || styles["default"];
        polylines.push(renderer.drawPolyline(segment.coordinates, style.background));
        polylines.push(renderer.drawPolyline(segment.coordinates, style.main));
      });
      return polylines;
    }
  }, {
    key: "renderTodoStatusLiveView",
    value: function renderTodoStatusLiveView(segments, renderer) {
      var polylines = [];
      var styles = this.liveViewPathStyles;
      segments.forEach(function (segment) {
        var style = styles[segment.type] || styles["default"];
        polylines.push(renderer.drawPolyline(segment.coordinates, style.background));
        polylines.push(renderer.drawPolyline(segment.coordinates, style.main));
      });
      return polylines;
    }
  }, {
    key: "renderStatus",
    value: function renderStatus(pathData) {
      var i;
      var j;
      var features;
      var path = [];
      var renderer = this.statusAndRemarksRenderer;
      var styles = this.pathStyles;
      if (!pathData || !pathData.features || !this.showStatusAndRemarks) return;
      features = pathData.features;
      renderer.clearContainer();
      for (i = 0; i < features.length; i += 1) {
        var feature = features[i];
        var segment = {
          type: feature.properties.TYPE || 'default',
          coordinates: []
        };
        switch (feature.geometry.type) {
          case 'LineString':
            for (j = 0; j < feature.geometry.coordinates.length; j += 1) {
              var point = new window.IWCoordinate(feature.geometry.coordinates[j][0], feature.geometry.coordinates[j][1]);
              segment.coordinates.push(point);
            }
            break;
          case 'Point':
            {
              if (!feature.properties || !feature.properties.STATE) break;
              var marker = this.createStatusMarker(new window.IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1]), feature.properties.STATE);
              this.map.getOverlayManager().getLayer(this.REMARKS_MARKER_LAYOUT).addOverlay(marker);
              break;
            }
          default:
            console.debug('Unsupported geometry type');
            break;
        }
        path.push(segment);
      }
      window.statusBGPolyline = [];
      window.statusPolyline = [];
      var keys = Object.keys(path);
      for (i = keys.length - 1; i >= 0; i--) {
        var _segment2 = path[i];
        var style = styles[_segment2.type] || styles["default"];
        window.statusBGPolyline.push(renderer.drawPolyline(_segment2.coordinates, style.background));
        window.statusPolyline.push(renderer.drawPolyline(_segment2.coordinates, style.main));
      }
      renderer.render();
    }
  }, {
    key: "buildDotTable",
    value: function buildDotTable() {
      var _this12 = this;
      window.tableSettings = window.storage.getTableSettings();
      var tableContainer = $('#dot-table');
      var currentMod = window.storage.getFollowMeMod();
      if (tableSettings.showTable && tableSettings.showTable !== undefined) {
        tableContainer.removeClass('d-none');
      } else {
        tableContainer.addClass('d-none');
        return;
      }
      var dots = this.getRawTrackDots();
      window.customEventKeys = Object.keys(customEventsAttributes);
      var table = $('<div class="table">');
      var header = $('#dot-table-header');
      var body = $('#dot-table-body');
      body.empty();
      var usedCustomEventAttributes = [];
      dots.forEach(function (dot) {
        if (dot.event && dot.event.constructor.name === 'EventCustom') {
          usedCustomEventAttributes = usedCustomEventAttributes.concat(Object.keys(dot.event._content));
        }
      });
      window.customEventKeys = customEventKeys.filter(function (key) {
        return usedCustomEventAttributes.includes(key);
      });
      header.find('.custom-event-header').each(function (i, ele) {
        $(ele).remove();
      });
      window.customEventKeys.forEach(function (key) {
        if (!$("#dot-table-header-".concat(key)).length) {
          var eventHeader = $("<th class=\"custom-event-header\" id=\"dot-table-header-".concat(key, "\">").concat(customEventsAttributes[key].name, "</th>"));
          header.append(eventHeader);
        }
      });
      window.defaultEventSelect = $('<select onchange="followmeMap.defaultEventChanged(this, this.value)" data-eventtype="default" class="custom-field-select">' + '<option value="-1">---</option></select>');
      defaultEvents.forEach(function (event) {
        if (window.CONSTANTS.DYNAMIC_DEFAULT_EVENTS.includes(event.id)) {
          defaultEventSelect.append($("<option value=\"".concat(event.id, "\" data-translation-key=\"").concat(CONSTANTS.DEFAULT_EVENT_KEYS_MOD[currentMod][event.id], "\"></option>")));
        } else {
          defaultEventSelect.append($("<option value=\"".concat(event.id, "\" data-translation-key=\"").concat(CONSTANTS.DEFAULT_EVENT_TRANSLATION_MAP[event.id], "\"></option>")));
        }
      });
      dots.forEach(function (dot, i) {
        _this12.addRowToDotTable(dot, i, body);
      });
      this.hideDisabledCells();
      this.highlightTableRows(this.selectedDots);
      window.translateTableElements();
    }
  }, {
    key: "customEventValueChanged",
    value: function customEventValueChanged(row, value, type) {
      var dot = this.mapDots.getByIndex(row);
      if (dot._event) {
        dot._event._content[type] = value;
        this.saveTrackDots();
        this.redrawPartly([row]);
      } else {
        var foundDefinition;
        window.storage.getCustomEventDefinitions().forEach(function (def) {
          if (def._definition.properties[type]) {
            foundDefinition = def;
          }
        });
        if (foundDefinition) {
          var content = {};
          content[type] = value;
          Object.keys(foundDefinition._definition.properties).forEach(function (prop) {
            if (!content[prop]) {
              content[prop] = '';
            }
          });
          dot.setEventFromTable(new _EventCustom["default"](parseInt(foundDefinition._definition.code, 10), foundDefinition._definition.title, content, foundDefinition._color, true));
          this.saveTrackDots();
          this.redrawPartly([row]);
        }
      }
      // this.lastChangedEvent = dot._event;
    }
  }, {
    key: "textEventValueChanged",
    value: function textEventValueChanged(row, value) {
      var dot = this.mapDots.getByIndex(row);
      if (dot._event) {
        dot._event._name = value;
      } else {
        var newEvent = new _Event["default"](1, value, '', '#6766bf', false, true);
        dot.setEventFromTable(newEvent);
      }
      this.saveTrackDots();
      this.redrawPartly([row]);
    }
  }, {
    key: "defaultEventChanged",
    value: function defaultEventChanged(ele, value) {
      var dotIndex = $(ele).parent().data('row-index');
      if (value > 0) {
        this.assignEventToDots(value, dotIndex);
      } else {
        this.removeEventFromDot(dotIndex);
      }
    }
  }, {
    key: "clearDotTable",
    value: function clearDotTable() {
      $('#dot-table-body').empty();
    }
  }, {
    key: "hideDotTable",
    value: function hideDotTable() {
      this.clearDotTable();
      $('#dot-table').addClass('d-none');
      setMapFormat();
    }
  }, {
    key: "redrawDotTableRows",
    value: function redrawDotTableRows() {
      var _this13 = this;
      var body = $('#dot-table-body');
      body.empty();
      if (this.getRawTrackDots().length === 0) return;
      this.getRawTrackDots().forEach(function (dot, i) {
        _this13.addRowToDotTable(dot, i, body);
      });
      this.hideDisabledCells();
      this.highlightTableRows(this.selectedDots);
      window.translateTableElements();
    }
  }, {
    key: "hideDisabledCells",
    value: function hideDisabledCells() {
      Object.keys(tableSettings).forEach(function (settings) {
        var column = $("#dot-table-header-".concat(settings));
        if (column) {
          if (!tableSettings[settings]) {
            $(".".concat(settings, "-cell")).each(function (i, ele) {
              $(ele).addClass('d-none');
            });
            column.addClass('d-none');
          } else {
            column.removeClass('d-none');
          }
        }
      });
    }
  }, {
    key: "addRowToDotTable",
    value: function addRowToDotTable(dot, i, body) {
      var _this14 = this;
      var eventType;
      if (dot.event && dot.event._isDefault) {
        eventType = 'default';
      } else if (dot.event && dot.event.constructor.name === 'EventCustom') {
        eventType = 'custom';
      } else if (dot.event && !dot.event._isDefault) {
        eventType = 'text';
      }
      if (FollowmeMap.isTableRowHidden(tableSettings, eventType) && !this.selectedDots.includes(i)) return;
      var row = this.createDotTableRow(dot, i, eventType);
      row.click(function (e) {
        body.find('tr').each(function (i, tr) {
          $(tr).removeClass('table-primary');
        });
        row.addClass('table-primary');
        var redrawDots = [];
        redrawDots.push(i);
        _this14.selectedDots.forEach(function (dot) {
          redrawDots.push(dot);
        });
        _this14.selectedDots = [i];
        _this14.redrawPartly(redrawDots);
        _this14.map.setCenter(_this14.mapDots.getByIndex(i).getCoordinate());
      });
      body.append(row);
      if (eventType === 'default') {
        var defaultEventSelector = $("#default-event-selector-".concat(i));
        defaultEventSelector.find('select').val(dot.event._id);
        if (dot.event._id === 65539) {
          defaultEventSelector.find("[value=".concat(dot.event._id, "]")).data('translation-key', 'events.transfer');
        } else if (Object.keys(window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD).includes(dot.event._name)) {
          defaultEventSelector.find("[value=".concat(dot.event._id, "]")).data('translation-key', window.CONSTANTS.DEFAULT_EVENT_KEYS_MOD[dot.event._name][dot.event._id]);
        } else {
          defaultEventSelector.find("[value=".concat(dot.event._id, "]")).data('translation-key', window.CONSTANTS.DEFAULT_EVENT_TRANSLATION_MAP[dot.event._id]);
        }
      } else if (eventType === 'text') {
        $("#text-event-input-".concat(i)).val(dot.event._name);
      }
      this.disableTableInputs(i, eventType);
      row.find($("#eventtype-".concat(i))).on('change', function (e, ele) {
        var element = $("#eventtype-".concat(i));
        _this14.disableTableInputs(element.get(0).dataset.rowindex, element.val());
        _this14.removeEventFromDot(i);
        if (element.val() === 'custom' && _this14.lastChangedEvent) {
          var _dot = _this14.mapDots.getByIndex(i);
          _dot.setEventFromTable(_this14.lastChangedEvent);
          _this14.updateTableRow(i, _dot);
        }
      });
    }
  }, {
    key: "createDotTableRow",
    value: function createDotTableRow(dot, i, eventType) {
      var row = $('<tr id="dot-table-row-' + i + '"></tr>');
      row.append($("<td class=\"index-cell\">".concat(i + 1, "</td>")));
      row.append($("<td class=\"coordinates-cell\">".concat(dot.lat.toString().slice(0, 10), ", ").concat(dot.lon.toString().slice(0, 10), "</td>")));
      row.append($("<td class=\"eventtype-cell\">\n              <select data-rowindex=\"".concat(i, "\" id=\"eventtype-").concat(i, "\" data-eventtype=\"allEvents\" class=\"custom-field-select\">\n                    <option value=\"na\" ").concat(!eventType ? 'selected' : '', ">---</option>\n                    <option value=\"default\" ").concat(eventType === 'default' ? 'selected' : '', " data-translation-key=\"event-table.default-event\"></option>\n                    <option value=\"text\" ").concat(eventType === 'text' ? 'selected' : '', " data-translation-key=\"sidebar.user-generated-events\"></option>\n                    <option class=\"custom-event-option\" value=\"custom\" ").concat(eventType === 'custom' ? 'selected' : '', " data-translation-key=\"sidebar.custom-structure-events\"></option>\n              </select></td>")));
      if (customEventKeys.length <= 0) {
        row.find('.custom-event-option').addClass('d-none');
      }
      var defaultCell = $("<td class=\"default-cell\" data-row-index=\"".concat(i, "\" id=\"default-event-selector-").concat(i, "\">").concat(defaultEventSelect.get(0).outerHTML, "</td>"));
      row.append(defaultCell);
      row.append($("<td class=\"text-cell\"><input data-eventtype=\"text\" onchange=\"followmeMap.textEventValueChanged(".concat(i, ", this.value)\" class=\"custom-field-select\" maxlength=\"50\" type=\"text\" id=\"text-event-input-").concat(i, "\"></td>")));
      var usedCustomEvents = [];
      if (dot.event && dot.event._content) {
        usedCustomEvents = Object.keys(dot.event._content);
      }
      customEventKeys.forEach(function (key) {
        var eventAttr = customEventsAttributes[key];
        var value;
        if (usedCustomEvents.includes(key)) {
          value = dot.event._content[key];
        }
        switch (eventAttr.type) {
          case 'boolean':
            {
              var cell = $("<td class=\"".concat(key, "-cell\" id=\"").concat(key, "-").concat(i, "\"><select onchange=\"followmeMap.customEventValueChanged(").concat(i, ", this.value, $(this).data('key'))\" data-key=\"").concat(key, "\" data-eventtype=\"custom\" class=\"custom-field-select\"><option value=\"undefined\">---</option><option value=\"true\" data-translation-key=\"events.yes\"></option><option value=\"false\" data-translation-key=\"events.no\"></option></select></td>"));
              if (value === undefined) {
                cell.find('select').val('undefined');
              } else {
                cell.find('select').val(value.toString());
              }
              row.append(cell);
              break;
            }
          case 'integer':
            row.append($("<td class=\"".concat(key, "-cell\" id=\"").concat(key, "-").concat(i, "\"><input onchange=\"followmeMap.customEventValueChanged(").concat(i, ", this.value, $(this).data('key'))\" data-key=\"").concat(key, "\" value=\"").concat(value !== undefined ? value : '', "\" data-eventtype=\"custom\"  type=\"number\" autocomplete=\"off\" step=\"1\" min=\"0\" class=\"custom-field\"></td>")));
            break;
          case 'float':
            row.append($("<td class=\"".concat(key, "-cell\" id=\"").concat(key, "-").concat(i, "\"><input onchange=\"followmeMap.customEventValueChanged(").concat(i, ", this.value, $(this).data('key'))\" data-key=\"").concat(key, "\" value=\"").concat(value !== undefined ? value : '', "\" data-eventtype=\"custom\"  type=\"number\" autocomplete=\"off\" min=\"0\" step=\"0.01\" class=\"custom-field\"></td>")));
            break;
          case 'string':
            row.append($("<td class=\"".concat(key, "-cell\" id=\"").concat(key, "-").concat(i, "\"><input onchange=\"followmeMap.customEventValueChanged(").concat(i, ", this.value, $(this).data('key'))\" data-key=\"").concat(key, "\" value=\"").concat(value !== undefined ? value : '', "\" data-eventtype=\"custom\"  type=\"text\" autocomplete=\"off\" class=\"custom-field\"></td>")));
            break;
          default:
            break;
        }
      });
      return row;
    }
  }, {
    key: "disableTableInputs",
    value: function disableTableInputs(rowIndex, eventType) {
      var row = $("#dot-table-row-".concat(rowIndex));
      row.find('input').each(function (i, input) {
        if (input.dataset.eventtype !== eventType && input.dataset.eventtype !== 'allEvents') {
          $(input).attr('disabled', true);
        } else {
          $(input).attr('disabled', false);
        }
      });
      row.find('select').each(function (i, select) {
        if (select.dataset.eventtype !== eventType && select.dataset.eventtype !== 'allEvents') {
          $(select).attr('disabled', true);
        } else {
          $(select).attr('disabled', false);
        }
      });
    }
  }, {
    key: "highlightTableRows",
    value: function highlightTableRows(selectedDots) {
      if (selectedDots.some(function (dot) {
        return dot < 0;
      })) return;
      if (!$('#dot-table').is(':visible')) return;
      var rows = $('#dot-table-body').find('.table-primary');
      rows.each(function (i, tr) {
        $(tr).removeClass('table-primary');
      });
      selectedDots.forEach(function (dotIndex) {
        $("#dot-table-row-".concat(dotIndex)).addClass('table-primary');
      });
      var scrollTo = $("#dot-table-row-".concat(selectedDots[0]));
      if (scrollTo.get(0)) {
        scrollTo.get(0).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      } else {
        this.redrawDotTableRows();
      }
    }
  }, {
    key: "updateTableRow",
    value: function updateTableRow(rowIndex, dot) {
      var inputs = $("#dot-table-row-".concat(rowIndex)).find('[data-key]');
      inputs.each(function (i, input) {
        var key = $(input).data('key');
        if (dot._event._content[key]) {
          $(input).val(dot._event._content[key]);
        }
      });
    }
  }, {
    key: "toggleSelectPolygon",
    value: function toggleSelectPolygon() {
      this.selectPolygonActive = !this.selectPolygonActive;
      var lassoBtn = $('#lasso-select-btn');
      if (this.selectPolygonActive) {
        lassoBtn.parent().data('title-translation-key', 'editor.titles.disable-polygon-select');
        lassoBtn.addClass('inactive');
      } else {
        lassoBtn.parent().data('title-translation-key', 'editor.titles.enable-polygon-select');
        lassoBtn.removeClass('inactive');
      }
      window.translateElements();
      lassoBtn.parent().tooltip('hide');
      lassoBtn.parent().tooltip('show');
    }
  }, {
    key: "initHybrid",
    value: function initHybrid() {
      var _this15 = this;
      var URL = 'https://wmts.geo.admin.ch/EPSG/3857/1.0.0/WMTSCapabilities.xml';
      var parser = new IWWMTSParser();
      parser.parse(URL, function (layers) {
        var layer = layers.find(function (it) {
          return it.id === 'ch.swisstopo.swissimage';
        });
        _this15.swisstopoHybrid = IWWMTSUtils.createMapTypeFromWMTSLayer(_this15.map, layer);
        _this15.swisstopoHybrid.setName('swisstopo-hybrid');
        var copyright = _this15.map.getOptions().getMapTypeByName('tomtom-latest').getCopyright();
        copyright = copyright.slice(0, copyright.indexOf(',') + 2) + 'swisstopo, ' + copyright.slice(copyright.indexOf(',') + 2);
        _this15.swisstopoHybrid.setCopyright(copyright);
        var serverConfig = _this15.map.getOptions().getMapTypeByName('tomtom-latest').getTilesServerConfig();
        var streets = new IWStreetsPostProcessor(_this15.map, serverConfig);
        _this15.swisstopoHybrid.setPostProcessor(streets);
        _this15.map.setMapType(_this15.swisstopoHybrid);
      });
    }
  }, {
    key: "initAir",
    value: function initAir() {
      var _this16 = this;
      var URL = 'https://wmts.geo.admin.ch/EPSG/3857/1.0.0/WMTSCapabilities.xml';
      var parser = new IWWMTSParser();
      parser.parse(URL, function (layers) {
        var layer = layers.find(function (it) {
          return it.id === 'ch.swisstopo.swissimage';
        });
        _this16.swisstopoAir = IWWMTSUtils.createMapTypeFromWMTSLayer(_this16.map, layer);
        _this16.swisstopoAir.setName('swisstopo-air');
        var copyright = 'infoware, swisstopo';
        _this16.swisstopoAir.setCopyright(copyright);
        _this16.map.setMapType(_this16.swisstopoAir);
      });
    }
  }, {
    key: "setWMTSHybrid",
    value: function setWMTSHybrid() {
      if (this.swisstopoHybrid) {
        this.map.setMapType(this.swisstopoHybrid);
      } else {
        this.initHybrid();
      }
    }
  }, {
    key: "setWMTSAir",
    value: function setWMTSAir() {
      if (this.swisstopoAir) {
        this.map.setMapType(this.swisstopoAir);
      } else {
        this.initAir();
      }
    }
  }], [{
    key: "getAngle",
    value: function getAngle(cord1, cord2) {
      var toRadians = function toRadians(value) {
        return value * Math.PI / 180;
      };
      var toDegrees = function toDegrees(radians) {
        return radians * 180 / Math.PI;
      };
      var pointA = cord1.toWGS84();
      var pointB = cord2.toWGS84();
      var delta = toRadians(pointB.getX() - pointA.getX());
      var log;
      var theta;

      // if delta over 180° take shorter rhumb line across the anti-meridian
      if (delta > Math.PI) delta -= 2 * Math.PI;
      if (delta < -Math.PI) delta += 2 * Math.PI;
      log = Math.log(Math.tan(toRadians(pointB.getY()) / 2 + Math.PI / 4) / Math.tan(toRadians(pointA.getY()) / 2 + Math.PI / 4));
      theta = Math.atan2(delta, log);
      return (toDegrees(theta) + 360) % 360;
    }
  }, {
    key: "isTableRowHidden",
    value: function isTableRowHidden(tableSettings, eventType) {
      if (!tableSettings.showEmpty && !eventType) {
        return true;
      }
      if (tableSettings[eventType] !== undefined && !tableSettings[eventType]) {
        return true;
      }
      return 0;
    }
  }]);
}();
if (typeof window !== 'undefined') window.FollowmeMap = FollowmeMap;
module.exports = FollowmeMap;

},{"./FollowMeMapUtils":1,"./track/Dot":4,"./track/Dots":5,"./track/Event":6,"./track/EventCustom":7,"./utils/InstructionsTranslator":10,"robust-point-in-polygon":13}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _FollowMeUtils = _interopRequireDefault(require("../FollowMeUtils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dot = exports["default"] = /*#__PURE__*/function () {
  function Dot(latitude, longitude, event) {
    _classCallCheck(this, Dot);
    this._latitude = latitude;
    this._longitude = longitude;
    this._event = event;
    this._marker = null;
    this._markerEvent = null;
  }
  return _createClass(Dot, [{
    key: "setLatitude",
    value: function setLatitude(latitude) {
      this._latitude = latitude;
      this._updateInheritedFields(this._event);
    }
  }, {
    key: "setLongitude",
    value: function setLongitude(longitude) {
      this._longitude = longitude;
      this._updateInheritedFields(this._event);
    }
  }, {
    key: "setEvent",
    value: function setEvent(event) {
      this._updateInheritedFields(event);
      this._event = event;
      window.followmeMap.buildDotTable();
    }
  }, {
    key: "setEventFromTable",
    value: function setEventFromTable(event) {
      this._updateInheritedFields(event);
      this._event = event;
    }
  }, {
    key: "setMarker",
    value: function setMarker(marker) {
      this._marker = marker;
    }
  }, {
    key: "setMarkerEvent",
    value: function setMarkerEvent(markerEvent) {
      this._markerEvent = markerEvent;
    }
  }, {
    key: "getLatitude",
    value: function getLatitude() {
      return this._latitude;
    }
  }, {
    key: "getLongitude",
    value: function getLongitude() {
      return this._longitude;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      // eslint-disable-next-line no-undef
      return new IWCoordinate(this._longitude, this._latitude, IWCoordinate.WGS84);
    }
  }, {
    key: "getEvent",
    value: function getEvent() {
      return this._event;
    }
  }, {
    key: "getMarker",
    value: function getMarker() {
      return this._marker;
    }
  }, {
    key: "getMarkerEvent",
    value: function getMarkerEvent() {
      return this._markerEvent;
    }
  }, {
    key: "getHash",
    value: function getHash() {
      return _FollowMeUtils["default"].hashString(this._latitude.toString() + this._longitude.toString() + JSON.stringify(this._event));
    }
  }, {
    key: "isDrawable",
    value: function isDrawable() {
      return typeof this._event === 'undefined' || this._event.constructor.name !== 'EventCustomDefinition';
    }
  }, {
    key: "hasEvent",
    value: function hasEvent() {
      return typeof this._event !== 'undefined';
    }
  }, {
    key: "hasMarkerEvent",
    value: function hasMarkerEvent() {
      return this._markerEvent !== null && typeof this._markerEvent !== 'undefined';
    }
  }, {
    key: "hasMarker",
    value: function hasMarker() {
      return this._marker !== null && typeof this._marker !== 'undefined';
    }
  }, {
    key: "clearEvent",
    value: function clearEvent() {
      this._event = undefined;
    }
  }, {
    key: "clearMarker",
    value: function clearMarker() {
      this._marker = null;
    }
  }, {
    key: "clearMarkerEvent",
    value: function clearMarkerEvent() {
      this._markerEvent = null;
    }
  }, {
    key: "_updateInheritedFields",
    value: function _updateInheritedFields(event) {
      if (!event || event.constructor.name !== 'EventCustom') return;
      var content = event.getContent();

      // eslint-disable-next-line no-restricted-syntax
      for (var item in content) {
        // eslint-disable-next-line no-continue
        if (!(item in content)) continue;
        if (['latitude', 'lat'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLatitude();
        if (['longitude', 'long', 'lng', 'lon'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLongitude();
      }
    }
  }]);
}();
module.exports = Dot;

},{"../FollowMeUtils":2}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dots = exports["default"] = /*#__PURE__*/function () {
  function Dots() {
    _classCallCheck(this, Dots);
    this._dots = [];
    this._definitions = {};
  }
  return _createClass(Dots, [{
    key: "add",
    value: function add(dot) {
      this._dots.push(dot);
      this.addDotDefinition(dot);
    }
  }, {
    key: "addAtIndex",
    value: function addAtIndex(index, dot) {
      this._dots.splice(index, 0, dot);
      this.addDotDefinition(dot);
      if (typeof window !== 'undefined') {
        window.followmeMap.buildDotTable();
      }
    }
  }, {
    key: "popDotDefinitions",
    value: function popDotDefinitions() {
      var definitions = [];
      var dots = [];
      this._dots.forEach(function (dot) {
        if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustomDefinition') {
          dots.push(dot);
          return;
        }
        definitions.push(dot.getEvent());
      });
      this._dots = dots;
      return definitions;
    }
  }, {
    key: "addDotDefinition",
    value: function addDotDefinition(dot) {
      if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustomDefinition') return;
      var eventCode = parseInt(dot.getEvent().getDefinition().code, 10);
      this._definitions[eventCode] = dot.getEvent();
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      return this._dots.length;
    }
  }, {
    key: "getTotalVisible",
    value: function getTotalVisible() {
      return this._dots.filter(function (dot) {
        return dot.isDrawable();
      }).length;
    }
  }, {
    key: "get",
    value: function get() {
      return this._dots;
    }
  }, {
    key: "getByEventCustomDefinitionCode",
    value: function getByEventCustomDefinitionCode(code) {
      for (var i = 0; i < this._dots.length; i++) {
        if (this._dots[i].hasEvent() && this._dots[i].getEvent().constructor.name === 'EventCustomDefinition' && this._dots[i].getEvent().getDefinition().code === code) {
          return this._dots[i];
        }
      }
      return null;
    }
  }, {
    key: "refreshDefinitions",
    value: function refreshDefinitions() {
      this._definitions = {};
      for (var i = 0; i < this._dots.length; i++) {
        if (this._dots[i].hasEvent() && this._dots[i].getEvent().constructor.name === 'EventCustomDefinition') {
          var eventCode = parseInt(this._dots[i].getEvent().getDefinition().code, 10);
          this._definitions[eventCode] = this._dots[i].getEvent();
        }
      }
    }
  }, {
    key: "getDefinitions",
    value: function getDefinitions() {
      return this._definitions;
    }
  }, {
    key: "getByIndex",
    value: function getByIndex(index) {
      return this._dots[index];
    }
  }, {
    key: "deleteDots",
    value: function deleteDots(dotsIndexesToDelete) {
      this._dots = this._dots.filter(function (dot, index) {
        return dotsIndexesToDelete.indexOf(index) === -1;
      });
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(dots) {
      var _this = this;
      this._dots = [];
      dots.forEach(function (dot) {
        _this._dots.push(dot);
      });
    }
  }]);
}();
module.exports = Dots;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Event = exports["default"] = /*#__PURE__*/function () {
  function Event(id, name, description, color, isDefault, isDrawable) {
    _classCallCheck(this, Event);
    this._id = id;
    this._name = name;
    this._description = description;
    this._color = color;
    this._isDefault = isDefault;
    this._isDrawable = isDrawable;
  }
  return _createClass(Event, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this._description;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getIsDefault",
    value: function getIsDefault() {
      return this._isDefault;
    }
  }, {
    key: "getIsEditable",
    value: function getIsEditable() {
      return !this._isDefault || this._id >= 45000 && this._id < 46000;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }]);
}();
module.exports = Event;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventCustom = exports["default"] = /*#__PURE__*/function () {
  function EventCustom(id, name, content, color, isDrawable) {
    _classCallCheck(this, EventCustom);
    this._id = id;
    this._name = name;
    this._content = content;
    this._color = color;
    this._isDrawable = isDrawable;
  }
  return _createClass(EventCustom, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this._content;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }], [{
    key: "getIsEditable",
    value: function getIsEditable() {
      return true;
    }
  }]);
}();
module.exports = EventCustom;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventCustomDefinition = exports["default"] = /*#__PURE__*/function () {
  function EventCustomDefinition(id, color, definition, isDrawable) {
    _classCallCheck(this, EventCustomDefinition);
    this._id = id;
    this._color = color;
    this._definition = definition;
    this._isDrawable = isDrawable;
  }
  return _createClass(EventCustomDefinition, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getDefinition",
    value: function getDefinition() {
      return this._definition;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }], [{
    key: "getIsEditable",
    value: function getIsEditable() {
      return false;
    }
  }]);
}();
if (typeof window !== 'undefined') window.EventCustomDefinition = EventCustomDefinition;
module.exports = EventCustomDefinition;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var translations = {
  followthecourse: {
    en: 'Follow the course',
    de: 'Folgen Sie dem Straßenverlauf'
  },
  nodatareceived: {
    en: 'Position cannot be determined',
    de: 'Position kann zur Zeit nicht bestimmt werden'
  },
  artakkfemale: {
    en: 'the',
    de: 'die'
  },
  artakkmale: {
    en: 'the',
    de: 'den'
  },
  artakkneutral: {
    en: 'the',
    de: 'das'
  },
  artunknown: {
    en: 'the',
    de: ''
  },
  now: {
    en: 'Now',
    de: 'Jetzt'
  },
  turnlsoft: {
    en: 'turn soft left',
    de: 'halb links abbiegen'
  },
  turnrsoft: {
    en: 'turn soft right',
    de: 'halb rechts abbiegen'
  },
  turnlsharp: {
    en: 'turn hard left',
    de: 'scharf links abbiegen'
  },
  turnrsharp: {
    en: 'turn hard right',
    de: 'scharf rechts abbiegen'
  },
  turnl: {
    en: 'turn left',
    de: 'links abbiegen'
  },
  turnr: {
    en: 'turn right',
    de: 'rechts abbiegen'
  },
  straight: {
    en: 'drive straight',
    de: 'gerade aus fahren'
  },
  'meters+': {
    en: 'meters',
    de: 'Metern'
  },
  followthisstreet: {
    en: 'Follow this road for',
    de: 'Folgen Sie dieser Straße noch'
  },
  endofstreet: {
    en: 'At the end of the road',
    de: 'Am Ende der Straße'
  },
  then: {
    en: ', then',
    de: ', dann'
  },
  uturn: {
    en: 'If possible please make a legal uturn',
    de: 'Bitte wenden'
  },
  reacheddestination: {
    en: 'you have reached your destination',
    de: 'haben Sie Ihr Ziel erreicht'
  },
  rbintro: {
    en: 'Exit roundabout at the',
    de: 'Nehmen Sie im Kreisverkehr die'
  },
  exit: {
    en: 'exit',
    de: 'Ausfahrt'
  },
  '1th': {
    en: '1st',
    de: 'erste'
  },
  '2th': {
    en: '2nd',
    de: 'zweite'
  },
  '3th': {
    en: '3rd',
    de: 'dritte'
  },
  '4th': {
    en: '4th',
    de: 'vierte'
  },
  '5th': {
    en: '5th',
    de: 'fünfte'
  },
  '6th': {
    en: '6th',
    de: 'sechste'
  },
  '7th': {
    en: '7th',
    de: 'siebte'
  },
  '8th': {
    en: '8th',
    de: 'achte'
  },
  '9th': {
    en: '9th',
    de: 'neunte'
  },
  '10th': {
    en: '10th',
    de: 'zehnte'
  },
  stayl: {
    en: 'stay left',
    de: 'halten sie sich links'
  },
  stayr: {
    en: 'stay right',
    de: 'halten sie sich rechts'
  },
  leaver: {
    en: 'exit right',
    de: 'rechts abfahren'
  },
  leavel: {
    en: 'exit left',
    de: 'links abfahren'
  },
  '1dat': {
    en: 'one',
    de: 'einem'
  },
  taketheferry: {
    en: 'take the ferry',
    de: 'nehmen Sie die Fähre'
  },
  trafficjam1: {
    en: 'Your route is being recalculated, using up to date trafic information',
    de: 'Die Route wird aufgrund aktueller Verkehrsmeldungen neu berechnet'
  },
  verylong: {
    en: 'a while',
    de: 'sehr lange'
  },
  'drive;to': {
    en: ', Drive to',
    de: ', Fahren Sie in Richtung'
  },
  drive: {
    en: ', Drive',
    de: ', Fahren Sie'
  },
  ';into': {
    en: ';into',
    de: ';in'
  },
  ';onto': {
    en: ';onto',
    de: ';auf'
  },
  'destination;is;right': {
    en: ', Your destination is on the right side',
    de: ', Das Ziel ligt auf der rechten Seite'
  },
  'destination;is;left': {
    en: ', Your destination is on the left side',
    de: ', Das Ziel ligt auf der linken Seite'
  },
  takethe: {
    en: 'Take the',
    de: 'Nehmen Sie die'
  },
  ';kms+': {
    en: ';kilometers',
    de: ';Kilometern'
  },
  ';kms': {
    en: ';kilometers',
    de: ';Kilometern'
  },
  ';km+': {
    en: ';kilometer',
    de: ';Kilometer'
  },
  ';km': {
    en: ';kilometer',
    de: ';Kilometer'
  },
  ', a': {
    en: '. a',
    de: ''
  },
  ';miles+': {
    en: ';Miles',
    de: ';Meilen'
  },
  ';mile+': {
    en: ';Miles',
    de: ';Meilen'
  },
  '0;point': {
    en: 'Point',
    de: 'Null Komma'
  },
  'str.': {
    en: 'street',
    de: 'Straße'
  },
  street: {
    en: 'street',
    de: 'Straße'
  },
  offroad: {
    en: 'offroad',
    de: 'offroad'
  },
  na: {
    en: '',
    de: ''
  }
};
var InstructionsTranslations = exports["default"] = /*#__PURE__*/function () {
  function InstructionsTranslations() {
    _classCallCheck(this, InstructionsTranslations);
  }
  return _createClass(InstructionsTranslations, [{
    key: "getByTextAndLanguage",
    value: function getByTextAndLanguage(text, language) {
      if (text in translations && language in translations[text]) {
        return translations[text][language];
      }
      if (text in translations && 'en' in translations[text]) {
        return translations[text].en;
      }
      return text;
    }
  }]);
}();
module.exports = InstructionsTranslations;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _InstructionsTranslations = _interopRequireDefault(require("./InstructionsTranslations"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InstructionsTranslator = exports["default"] = /*#__PURE__*/function () {
  function InstructionsTranslator(language) {
    _classCallCheck(this, InstructionsTranslator);
    this.translator = new _InstructionsTranslations["default"]();
    this.language = language;
  }
  return _createClass(InstructionsTranslator, [{
    key: "getTranslationForSegment",
    value: function getTranslationForSegment(segment) {
      return this.translator.getByTextAndLanguage(segment.toLowerCase(), this.language);
    }
  }, {
    key: "getTranslationForText",
    value: function getTranslationForText(text) {
      var segments = text.split(' ');
      var translations = segments.map(this.getTranslationForSegment.bind(this)).filter(function (value) {
        return value;
      });
      return translations.join(' ').replace(/ , /g, ', ');
    }
  }]);
}();
module.exports = InstructionsTranslator;

},{"./InstructionsTranslations":9}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NMEAFormatter = exports["default"] = /*#__PURE__*/function () {
  function NMEAFormatter() {
    _classCallCheck(this, NMEAFormatter);
  }
  return _createClass(NMEAFormatter, [{
    key: "getTime",
    value:
    /**
     * @private
     */
    function getTime(date) {
      var hours = date.getUTCHours();
      var minutes = date.getUTCMinutes();
      var seconds = date.getUTCSeconds();
      return '' + (hours < 10 ? '0' + hours : hours) + (minutes < 10 ? '0' + minutes : minutes) + (seconds < 10 ? '0' + seconds : seconds);
    }
  }, {
    key: "format",
    value: function format(coordinate) {
      var wgs84 = coordinate.toWGS84();
      var timestamp = new Date();
      var time = this.getTime(timestamp);
      var date = this.getDateDayFirst(timestamp);
      var lat = this.getDegreeMinutesSeconds(wgs84.getY(), 'latitude');
      var lon = this.getDegreeMinutesSeconds(wgs84.getX(), 'longitude');
      var rmc = 'GPRMC,' + time + ',A,' + lat + ',' + lon + ',,,' + date + ',,,A';
      return '$' + rmc + '*' + this.getChecksum(rmc);
    }

    /**
     * @private
     */
  }, {
    key: "getDateDayFirst",
    value: function getDateDayFirst(date) {
      var year = date.getUTCFullYear();
      var month = date.getUTCMonth() + 1;
      var day = date.getUTCDate();
      return '' + (day < 10 ? '0' + day : day) + (month < 10 ? '0' + month : month) + year % 100;
    }

    /**
     * @private
     */
  }, {
    key: "getDegreeMinutesSeconds",
    value: function getDegreeMinutesSeconds(degreesDecimal, mode) {
      var negative = degreesDecimal < 0;
      degreesDecimal = Math.abs(degreesDecimal);
      var degrees = Math.floor(degreesDecimal);
      var remainder = degreesDecimal - degrees;
      var minutes = Math.floor(60 * remainder);
      remainder = 60 * remainder - minutes; // 60 * remainder is the decimal value for minutes and seconds

      var s = Math.floor(remainder * 10000);
      var minuteFraction = s < 10 ? '000' + s : s < 100 ? '00' + s : s < 1000 ? '0' + s : '' + s;
      var hemisphere;
      if (mode === 'latitude') {
        // return XXYY.ZZZZ,b which is XXºYY'ZZZZ'' with being N or S
        hemisphere = negative ? 'S' : 'N';
        return this.toTwoPlaces(degrees) + this.toTwoPlaces(minutes) + '.' + minuteFraction + ',' + hemisphere;
      }

      // return XXXYY.ZZZZ,l which is XXºYY'ZZZZ'' with l being W or E
      hemisphere = negative ? 'W' : 'E';
      return this.toThreePlaces(degrees) + this.toTwoPlaces(minutes) + '.' + minuteFraction + ',' + hemisphere;
    }

    /**
     * @private
     */
  }, {
    key: "toTwoPlaces",
    value: function toTwoPlaces(n) {
      if (n < 10) return '0' + n;
      return n.toString();
    }

    /**
     * @private
     */
  }, {
    key: "toThreePlaces",
    value: function toThreePlaces(n) {
      if (n < 10) return '00' + n;
      if (n < 100) return '0' + n;
      return n.toString();
    }

    /**
     * Returns the bitwise XOR of the ASCII codes in the specified string (as a hexadecimal number).
     * @private
     */
  }, {
    key: "getChecksum",
    value: function getChecksum(s) {
      var checksum = 0;
      for (var i = 0; i < s.length; i++) {
        checksum ^= s.charCodeAt(i);
      }
      return checksum.toString(16).toUpperCase();
    }
  }]);
}();
module.exports = NMEAFormatter;

},{}],12:[function(require,module,exports){
"use strict"

var twoProduct = require("two-product")
var robustSum = require("robust-sum")
var robustScale = require("robust-scale")
var robustSubtract = require("robust-subtract")

var NUM_EXPAND = 5

var EPSILON     = 1.1102230246251565e-16
var ERRBOUND3   = (3.0 + 16.0 * EPSILON) * EPSILON
var ERRBOUND4   = (7.0 + 56.0 * EPSILON) * EPSILON

function orientation_3(sum, prod, scale, sub) {
  return function orientation3Exact(m0, m1, m2) {
    var p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])))
    var n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]))
    var d = sub(p, n)
    return d[d.length - 1]
  }
}

function orientation_4(sum, prod, scale, sub) {
  return function orientation4Exact(m0, m1, m2, m3) {
    var p = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))))
    var n = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))))
    var d = sub(p, n)
    return d[d.length - 1]
  }
}

function orientation_5(sum, prod, scale, sub) {
  return function orientation5Exact(m0, m1, m2, m3, m4) {
    var p = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))))
    var n = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))))
    var d = sub(p, n)
    return d[d.length - 1]
  }
}

function orientation(n) {
  var fn =
    n === 3 ? orientation_3 :
    n === 4 ? orientation_4 : orientation_5

  return fn(robustSum, twoProduct, robustScale, robustSubtract)
}

var orientation3Exact = orientation(3)
var orientation4Exact = orientation(4)

var CACHED = [
  function orientation0() { return 0 },
  function orientation1() { return 0 },
  function orientation2(a, b) {
    return b[0] - a[0]
  },
  function orientation3(a, b, c) {
    var l = (a[1] - c[1]) * (b[0] - c[0])
    var r = (a[0] - c[0]) * (b[1] - c[1])
    var det = l - r
    var s
    if(l > 0) {
      if(r <= 0) {
        return det
      } else {
        s = l + r
      }
    } else if(l < 0) {
      if(r >= 0) {
        return det
      } else {
        s = -(l + r)
      }
    } else {
      return det
    }
    var tol = ERRBOUND3 * s
    if(det >= tol || det <= -tol) {
      return det
    }
    return orientation3Exact(a, b, c)
  },
  function orientation4(a,b,c,d) {
    var adx = a[0] - d[0]
    var bdx = b[0] - d[0]
    var cdx = c[0] - d[0]
    var ady = a[1] - d[1]
    var bdy = b[1] - d[1]
    var cdy = c[1] - d[1]
    var adz = a[2] - d[2]
    var bdz = b[2] - d[2]
    var cdz = c[2] - d[2]
    var bdxcdy = bdx * cdy
    var cdxbdy = cdx * bdy
    var cdxady = cdx * ady
    var adxcdy = adx * cdy
    var adxbdy = adx * bdy
    var bdxady = bdx * ady
    var det = adz * (bdxcdy - cdxbdy)
            + bdz * (cdxady - adxcdy)
            + cdz * (adxbdy - bdxady)
    var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz)
                  + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz)
                  + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz)
    var tol = ERRBOUND4 * permanent
    if ((det > tol) || (-det > tol)) {
      return det
    }
    return orientation4Exact(a,b,c,d)
  }
]

function slowOrient(args) {
  var proc = CACHED[args.length]
  if(!proc) {
    proc = CACHED[args.length] = orientation(args.length)
  }
  return proc.apply(undefined, args)
}

function proc (slow, o0, o1, o2, o3, o4, o5) {
  return function getOrientation(a0, a1, a2, a3, a4) {
    switch (arguments.length) {
      case 0:
      case 1:
        return 0;
      case 2:
        return o2(a0, a1)
      case 3:
        return o3(a0, a1, a2)
      case 4:
        return o4(a0, a1, a2, a3)
      case 5:
        return o5(a0, a1, a2, a3, a4)
    }

    var s = new Array(arguments.length)
    for (var i = 0; i < arguments.length; ++i) {
      s[i] = arguments[i]
    }
    return slow(s)
  }
}

function generateOrientationProc() {
  while(CACHED.length <= NUM_EXPAND) {
    CACHED.push(orientation(CACHED.length))
  }
  module.exports = proc.apply(undefined, [slowOrient].concat(CACHED))
  for(var i=0; i<=NUM_EXPAND; ++i) {
    module.exports[i] = CACHED[i]
  }
}

generateOrientationProc()
},{"robust-scale":14,"robust-subtract":15,"robust-sum":16,"two-product":17}],13:[function(require,module,exports){
module.exports = robustPointInPolygon

var orient = require('robust-orientation')

function robustPointInPolygon(vs, point) {
  var x = point[0]
  var y = point[1]
  var n = vs.length
  var inside = 1
  var lim = n
  for(var i = 0, j = n-1; i<lim; j=i++) {
    var a = vs[i]
    var b = vs[j]
    var yi = a[1]
    var yj = b[1]
    if(yj < yi) {
      if(yj < y && y < yi) {
        var s = orient(a, b, point)
        if(s === 0) {
          return 0
        } else {
          inside ^= (0 < s)|0
        }
      } else if(y === yi) {
        var c = vs[(i+1)%n]
        var yk = c[1]
        if(yi < yk) {
          var s = orient(a, b, point)
          if(s === 0) {
            return 0
          } else {
            inside ^= (0 < s)|0
          }
        }
      }
    } else if(yi < yj) {
      if(yi < y && y < yj) {
        var s = orient(a, b, point)
        if(s === 0) {
          return 0
        } else {
          inside ^= (s < 0)|0
        }
      } else if(y === yi) {
        var c = vs[(i+1)%n]
        var yk = c[1]
        if(yk < yi) {
          var s = orient(a, b, point)
          if(s === 0) {
            return 0
          } else {
            inside ^= (s < 0)|0
          }
        }
      }
    } else if(y === yi) {
      var x0 = Math.min(a[0], b[0])
      var x1 = Math.max(a[0], b[0])
      if(i === 0) {
        while(j>0) {
          var k = (j+n-1)%n
          var p = vs[k]
          if(p[1] !== y) {
            break
          }
          var px = p[0]
          x0 = Math.min(x0, px)
          x1 = Math.max(x1, px)
          j = k
        }
        if(j === 0) {
          if(x0 <= x && x <= x1) {
            return 0
          }
          return 1 
        }
        lim = j+1
      }
      var y0 = vs[(j+n-1)%n][1]
      while(i+1<lim) {
        var p = vs[i+1]
        if(p[1] !== y) {
          break
        }
        var px = p[0]
        x0 = Math.min(x0, px)
        x1 = Math.max(x1, px)
        i += 1
      }
      if(x0 <= x && x <= x1) {
        return 0
      }
      var y1 = vs[(i+1)%n][1]
      if(x < x0 && (y0 < y !== y1 < y)) {
        inside ^= 1
      }
    }
  }
  return 2 * inside - 1
}
},{"robust-orientation":12}],14:[function(require,module,exports){
"use strict"

var twoProduct = require("two-product")
var twoSum = require("two-sum")

module.exports = scaleLinearExpansion

function scaleLinearExpansion(e, scale) {
  var n = e.length
  if(n === 1) {
    var ts = twoProduct(e[0], scale)
    if(ts[0]) {
      return ts
    }
    return [ ts[1] ]
  }
  var g = new Array(2 * n)
  var q = [0.1, 0.1]
  var t = [0.1, 0.1]
  var count = 0
  twoProduct(e[0], scale, q)
  if(q[0]) {
    g[count++] = q[0]
  }
  for(var i=1; i<n; ++i) {
    twoProduct(e[i], scale, t)
    var pq = q[1]
    twoSum(pq, t[0], q)
    if(q[0]) {
      g[count++] = q[0]
    }
    var a = t[1]
    var b = q[1]
    var x = a + b
    var bv = x - a
    var y = b - bv
    q[1] = x
    if(y) {
      g[count++] = y
    }
  }
  if(q[1]) {
    g[count++] = q[1]
  }
  if(count === 0) {
    g[count++] = 0.0
  }
  g.length = count
  return g
}
},{"two-product":17,"two-sum":18}],15:[function(require,module,exports){
"use strict"

module.exports = robustSubtract

//Easy case: Add two scalars
function scalarScalar(a, b) {
  var x = a + b
  var bv = x - a
  var av = x - bv
  var br = b - bv
  var ar = a - av
  var y = ar + br
  if(y) {
    return [y, x]
  }
  return [x]
}

function robustSubtract(e, f) {
  var ne = e.length|0
  var nf = f.length|0
  if(ne === 1 && nf === 1) {
    return scalarScalar(e[0], -f[0])
  }
  var n = ne + nf
  var g = new Array(n)
  var count = 0
  var eptr = 0
  var fptr = 0
  var abs = Math.abs
  var ei = e[eptr]
  var ea = abs(ei)
  var fi = -f[fptr]
  var fa = abs(fi)
  var a, b
  if(ea < fa) {
    b = ei
    eptr += 1
    if(eptr < ne) {
      ei = e[eptr]
      ea = abs(ei)
    }
  } else {
    b = fi
    fptr += 1
    if(fptr < nf) {
      fi = -f[fptr]
      fa = abs(fi)
    }
  }
  if((eptr < ne && ea < fa) || (fptr >= nf)) {
    a = ei
    eptr += 1
    if(eptr < ne) {
      ei = e[eptr]
      ea = abs(ei)
    }
  } else {
    a = fi
    fptr += 1
    if(fptr < nf) {
      fi = -f[fptr]
      fa = abs(fi)
    }
  }
  var x = a + b
  var bv = x - a
  var y = b - bv
  var q0 = y
  var q1 = x
  var _x, _bv, _av, _br, _ar
  while(eptr < ne && fptr < nf) {
    if(ea < fa) {
      a = ei
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
        ea = abs(ei)
      }
    } else {
      a = fi
      fptr += 1
      if(fptr < nf) {
        fi = -f[fptr]
        fa = abs(fi)
      }
    }
    b = q0
    x = a + b
    bv = x - a
    y = b - bv
    if(y) {
      g[count++] = y
    }
    _x = q1 + x
    _bv = _x - q1
    _av = _x - _bv
    _br = x - _bv
    _ar = q1 - _av
    q0 = _ar + _br
    q1 = _x
  }
  while(eptr < ne) {
    a = ei
    b = q0
    x = a + b
    bv = x - a
    y = b - bv
    if(y) {
      g[count++] = y
    }
    _x = q1 + x
    _bv = _x - q1
    _av = _x - _bv
    _br = x - _bv
    _ar = q1 - _av
    q0 = _ar + _br
    q1 = _x
    eptr += 1
    if(eptr < ne) {
      ei = e[eptr]
    }
  }
  while(fptr < nf) {
    a = fi
    b = q0
    x = a + b
    bv = x - a
    y = b - bv
    if(y) {
      g[count++] = y
    } 
    _x = q1 + x
    _bv = _x - q1
    _av = _x - _bv
    _br = x - _bv
    _ar = q1 - _av
    q0 = _ar + _br
    q1 = _x
    fptr += 1
    if(fptr < nf) {
      fi = -f[fptr]
    }
  }
  if(q0) {
    g[count++] = q0
  }
  if(q1) {
    g[count++] = q1
  }
  if(!count) {
    g[count++] = 0.0  
  }
  g.length = count
  return g
}
},{}],16:[function(require,module,exports){
"use strict"

module.exports = linearExpansionSum

//Easy case: Add two scalars
function scalarScalar(a, b) {
  var x = a + b
  var bv = x - a
  var av = x - bv
  var br = b - bv
  var ar = a - av
  var y = ar + br
  if(y) {
    return [y, x]
  }
  return [x]
}

function linearExpansionSum(e, f) {
  var ne = e.length|0
  var nf = f.length|0
  if(ne === 1 && nf === 1) {
    return scalarScalar(e[0], f[0])
  }
  var n = ne + nf
  var g = new Array(n)
  var count = 0
  var eptr = 0
  var fptr = 0
  var abs = Math.abs
  var ei = e[eptr]
  var ea = abs(ei)
  var fi = f[fptr]
  var fa = abs(fi)
  var a, b
  if(ea < fa) {
    b = ei
    eptr += 1
    if(eptr < ne) {
      ei = e[eptr]
      ea = abs(ei)
    }
  } else {
    b = fi
    fptr += 1
    if(fptr < nf) {
      fi = f[fptr]
      fa = abs(fi)
    }
  }
  if((eptr < ne && ea < fa) || (fptr >= nf)) {
    a = ei
    eptr += 1
    if(eptr < ne) {
      ei = e[eptr]
      ea = abs(ei)
    }
  } else {
    a = fi
    fptr += 1
    if(fptr < nf) {
      fi = f[fptr]
      fa = abs(fi)
    }
  }
  var x = a + b
  var bv = x - a
  var y = b - bv
  var q0 = y
  var q1 = x
  var _x, _bv, _av, _br, _ar
  while(eptr < ne && fptr < nf) {
    if(ea < fa) {
      a = ei
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
        ea = abs(ei)
      }
    } else {
      a = fi
      fptr += 1
      if(fptr < nf) {
        fi = f[fptr]
        fa = abs(fi)
      }
    }
    b = q0
    x = a + b
    bv = x - a
    y = b - bv
    if(y) {
      g[count++] = y
    }
    _x = q1 + x
    _bv = _x - q1
    _av = _x - _bv
    _br = x - _bv
    _ar = q1 - _av
    q0 = _ar + _br
    q1 = _x
  }
  while(eptr < ne) {
    a = ei
    b = q0
    x = a + b
    bv = x - a
    y = b - bv
    if(y) {
      g[count++] = y
    }
    _x = q1 + x
    _bv = _x - q1
    _av = _x - _bv
    _br = x - _bv
    _ar = q1 - _av
    q0 = _ar + _br
    q1 = _x
    eptr += 1
    if(eptr < ne) {
      ei = e[eptr]
    }
  }
  while(fptr < nf) {
    a = fi
    b = q0
    x = a + b
    bv = x - a
    y = b - bv
    if(y) {
      g[count++] = y
    } 
    _x = q1 + x
    _bv = _x - q1
    _av = _x - _bv
    _br = x - _bv
    _ar = q1 - _av
    q0 = _ar + _br
    q1 = _x
    fptr += 1
    if(fptr < nf) {
      fi = f[fptr]
    }
  }
  if(q0) {
    g[count++] = q0
  }
  if(q1) {
    g[count++] = q1
  }
  if(!count) {
    g[count++] = 0.0  
  }
  g.length = count
  return g
}
},{}],17:[function(require,module,exports){
"use strict"

module.exports = twoProduct

var SPLITTER = +(Math.pow(2, 27) + 1.0)

function twoProduct(a, b, result) {
  var x = a * b

  var c = SPLITTER * a
  var abig = c - a
  var ahi = c - abig
  var alo = a - ahi

  var d = SPLITTER * b
  var bbig = d - b
  var bhi = d - bbig
  var blo = b - bhi

  var err1 = x - (ahi * bhi)
  var err2 = err1 - (alo * bhi)
  var err3 = err2 - (ahi * blo)

  var y = alo * blo - err3

  if(result) {
    result[0] = y
    result[1] = x
    return result
  }

  return [ y, x ]
}
},{}],18:[function(require,module,exports){
"use strict"

module.exports = fastTwoSum

function fastTwoSum(a, b, result) {
	var x = a + b
	var bv = x - a
	var av = x - bv
	var br = b - bv
	var ar = a - av
	if(result) {
		result[0] = ar + br
		result[1] = x
		return result
	}
	return [ar+br, x]
}
},{}]},{},[3])

